// import React, { useEffect, useRef, useMemo } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { Container, Row, Col } from 'react-bootstrap';
// import { useLanguage } from '../component/LanguageProvider';
// import SEO from '../component/SEO';
// import gsap from 'gsap';
// import {
//   FaUserFriends, FaRegClock, FaRocket, FaGlobeAmericas, FaAward, FaUserCheck,
//   FaArrowRight,
//   FaArrowLeft,
//   FaPlane,
//   FaCheckCircle
// } from 'react-icons/fa';

// // Swiper Imports
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Navigation, Autoplay } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

// import Particles from '../component/Particles';

// const flyviaServicesFullBilingual = [
//   // ---------------- Aviation Services ----------------
//   {
//     key: "privateJet",
//     title: { en: "Private Jet Charter", ar: "طيران خاص" },
//     desc: { en: "Luxury private flights tailored to your schedule and needs.", ar: "رحلات طيران فاخرة مخصصة حسب جدولك واحتياجاتك." },
//     text: {
//       en: `FlyVia provides fully personalized private jet charters across Europe. Travel on your schedule with full discretion and comfort. Services include customized flight plans, premium in-flight amenities, flexible departure and arrival times, secure boarding and luggage handling, and a dedicated travel concierge.`,
//       ar: `FlyVia توفر رحلات طيران خاصة مخصصة داخل أوروبا. سافر متى وأين تريد مع الخصوصية والراحة الكاملة. تشمل الخدمة: خطة رحلات شخصية، خدمات طعام ومرافق فاخرة على متن الطائرة، مرونة في مواعيد المغادرة والوصول، إجراءات أمنية للركاب والأمتعة، وخدمة كونسيرج مخصصة.`
//     },
//     benefits: { en: ["Complete discretion and privacy", "Luxury in-flight experience", "Flexible scheduling", "Ground transportation coordination"], ar: ["خصوصية كاملة", "تجربة سفر فاخرة", "مرونة في الجدول الزمني", "تنسيق النقل الأرضي"] },
//     audience: { en: "Executives, VIPs, Families", ar: "المديرون التنفيذيون، المشاهير، كبار الشخصيات، العائلات" },
//     duration: { en: "On-demand", ar: "حسب مسار الرحلة" },
//     image: "/https://swiftjetaviation.com/wp-content/uploads/2024/04/pngwing.com-5.png",
//     cta: { en: "Book Your Private Jet", ar: "احجز رحلتك الخاصة" },
//     stats: [
//       { label: { en: "Trips", ar: "رحلة" }, value: "720+" },
//       { label: { en: "Clients", ar: "عميل" }, value: "450+" },
//       { label: { en: "Hours", ar: "ساعة طيران" }, value: "625+" },
//       { label: { en: "Destinations", ar: "وجهة" }, value: "3+" }
//     ],
//     gallery: ["/https://swiftjetaviation.com/wp-content/uploads/2024/04/pngwing.com-5.png", "https://swiftjetaviation.com/wp-content/uploads/elementor/thumbs/SwiftJet-Company-Profile-1_Page_003_Image_0001-qmgd33872rlzbs40ws92f9i3enjdfzt3nl8mvdfpls.jpg", "https://swiftjetaviation.com/wp-content/uploads/2024/03/SwiftJet-Company-Profile-1_Page_005_Image_0001-1024x576.jpg","https://swiftjetaviation.com/wp-content/uploads/2024/03/SwiftJet-Company-Profile-1_Page_007_Image_0001-1024x576.jpg"]
//   },
//   {
//     key: "emptyLeg",
//     title: { en: "Empty Leg Flights", ar: "رحلات Empty Leg" },
//     desc: { en: "Premium travel opportunities on repositioning aircraft at exceptional value.", ar: "استمتع برحلات فاخرة بأسعار منخفضة على الطائرات المعاد تموضعها." },
//     text: {
//       en: `Take advantage of empty leg flights with FlyVia for luxury travel at a fraction of the cost. Perfect for travelers looking for premium aircraft without paying full charter prices. Services include up to 70% cost reduction, access to modern aircraft, real-time availability updates, and full concierge support.`,
//       ar: `استفد من رحلات Empty Leg مع FlyVia للسفر الفاخر بتكلفة منخفضة. تشمل الخدمة: خصم يصل إلى 70%، اختيار الطائرات الحديثة، تحديثات توافر الرحلات بشكل لحظي، ودعم كونسيرج للحجز.`
//     },
//     benefits: { en: ["Cost-effective luxury travel", "Premium aircraft access", "Real-time availability", "Concierge support included"], ar: ["سفر فاخر بتكلفة منخفضة", "الوصول إلى طائرات فاخرة", "توافر رحلات لحظي", "دعم كونسيرج للحجز"] },
//     audience: { en: "Luxury travelers", ar: "المسافرون الباحثون عن الفخامة بأسعار معقولة" },
//     duration: { en: "Depends on schedule", ar: "حسب جدول إعادة التموضع" },
//     image: "/gallery-4.png",
//     cta: { en: "Check Available Empty Legs", ar: "تحقق من الرحلات المتاحة" },
//     stats: [
//       { label: { en: "Savings", ar: "توفير" }, value: "70%" },
//       { label: { en: "Planes", ar: "طائرة" }, value: "15+" },
//       { label: { en: "Daily Flts", ar: "رحلات يومية" }, value: "5+" },
//       { label: { en: "Partners", ar: "شريك" }, value: "12+" }
//     ],
//     gallery: ["/gallery-4.png", "/gallery-5.png", "/gallery-6.png", "/gallery-1.png"]
//   },
//   {
//     key: "commercial",
//     title: { en: "Commercial Flight", ar: "رحلات تجارية" },
//     desc: { en: "Experience a distinctive blend of efficiency and comfort.", ar: "تجربة مميزة تجمع بين الكفاءة والراحة." },
//     text: {
//       en: `FlyVia ensures your commercial travel is seamless, with selected airlines offering comfort, reliability, and personalized attention for your business or leisure trips across Europe. Services include priority booking assistance, personalized itinerary, airport lounge access (optional), and travel insurance guidance.`,
//       ar: `FlyVia تضمن تجربة سفر تجارية سلسة مع شركات طيران مختارة توفر: المساعدة في حجز الأولوية، إعداد مسار الرحلة الشخصي، الوصول إلى صالات المطار (اختياري)، وإرشاد التأمين على السفر.`
//     },
//     benefits: { en: ["Reliable airline selection", "Seamless travel experience", "Comfort and efficiency combined", "Optional VIP amenities"], ar: ["موثوقية شركات الطيران", "تجربة سفر سلسة", "راحة وكفاءة مجتمعة", "خدمات VIP اختيارية"] },
//     audience: { en: "Business travelers, families", ar: "رجال الأعمال، العائلات" },
//     duration: { en: "Varies per flight schedule", ar: "حسب جدول الرحلة" },
//     image: "/gallery-7.png",
//     cta: { en: "Plan Your Trip", ar: "خطط رحلتك" },
//     stats: [
//       { label: { en: "Airlines", ar: "شركة طيران" }, value: "25+" },
//       { label: { en: "Global Net", ar: "شبكة عالمية" }, value: "100%" },
//       { label: { en: "Support", ar: "دعم" }, value: "24/7" },
//       { label: { en: "Classes", ar: "درجات" }, value: "3" }
//     ],
//     gallery: ["/gallery-7.png", "/gallery-8.png", "/gallery-9.png", "/gallery-10.png"]
//   },
//   {
//     key: "vipTerminal",
//     title: { en: "VIP Terminal Access", ar: "صالة كبار الشخصيات" },
//     desc: { en: "Skip the lines with private airport terminals and concierge service.", ar: "تجاوز الطوابير مع صالات خاصة وخدمة كونسيرج." },
//     text: {
//       en: `FlyVia offers access to VIP terminals in Europe’s busiest airports. Enjoy fast-track immigration, private lounges, and concierge assistance. Services include priority check-in and boarding, exclusive lounges with catering, private security lanes, and personalized concierge support.`,
//       ar: `FlyVia توفر الوصول إلى صالات VIP في أهم المطارات الأوروبية: تسجيل دخول سريع وأولوية في الصعود، صالات حصرية مع خدمات الطعام، مسارات أمنية خاصة، ودعم كونسيرج شخصي.`
//     },
//     benefits: { en: ["Time-saving airport experience", "Comfortable and private lounges", "Professional concierge services", "Stress-free travel start"], ar: ["توفير الوقت في إجراءات المطار", "راحة وصالات خاصة", "خدمة كونسيرج متميزة", "بدء السفر بلا قلق"] },
//     audience: { en: "Executives, VIP travelers", ar: "المديرون التنفيذيون، كبار الشخصيات" },
//     duration: { en: "Per flight or day use", ar: "لكل رحلة أو يوم" },
//     image: "/gallery-9.png",
//     cta: { en: "Reserve VIP Terminal", ar: "احجز صالة VIP" },
//     stats: [
//       { label: { en: "Terminals", ar: "صالة" }, value: "50+" },
//       { label: { en: "Cities", ar: "مدينة" }, value: "30+" },
//       { label: { en: "Min Stay", ar: "أقل انتظار" }, value: "15m" },
//       { label: { en: "Privacy", ar: "خصوصية" }, value: "100%" }
//     ],
//     gallery: ["/gallery-9.png", "/gallery-10.png", "/gallery-1.png", "/gallery-2.png"]
//   },
//   {
//     key: "tours",
//     title: { en: "Flight Sightseeing Tour", ar: "جولات طيران سياحية" },
//     desc: { en: "Experience Egypt's wonders in unparalleled style aboard our Zlin aircraft.", ar: "اكتشف عجائب مصر بأسلوب لا مثيل له على متن طائرات Zlin الخاصة بنا." },
//     text: {
//       en: "Experience Egypt's wonders in unparalleled style aboard our meticulously maintained Zlin aircraft or opt for the exhilarating adventure of our helicopters. Soar over Cairo and the Pyramids, where our expert pilots provide a bird's-eye view of these iconic landmarks. Revel in the magic of exclusive landings near the Pyramids, offering you a chance to step onto historic grounds and immerse yourself in their grandeur. Extend your gaze to the stunning landscapes of Hurgada, Gouna, and Luxor. Our Flight Sightseeing Tour captures the essence of Egypt's diverse beauty, from Cairo's bustling urbanity to the serene Red Sea coast and the historical richness of Luxor. Perfect for romantic dates, birthdays, and real estate tours, allowing VIP clients and investors to view locations and development progress, especially in areas like the New Administrative Capital.",
//       ar: "اكتشف عجائب مصر بأسلوب لا مثيل له على متن طائرات Zlin الخاصة بنا أو اختر المغامرة المثيرة عبر مروحياتنا. حلق فوق القاهرة والأهرامات حيث يقدم طيارونا الخبراء إطلالة بانورامية لهذه المعالم. استمتع بسحر الهبوط الحصري بالقرب من الأهرامات لتغوص في عظمتها التاريخية. جولاتنا تشمل أيضًا مناظر الغردقة، الجونة، والأقصر. مثالية للمناسبات الرومانسية، أعياد الميلاد، والجولات العقارية للمستثمرين لرؤية التطورات في العاصمة الإدارية الجديدة."
//     },
//     benefits: { en: ["Unique aerial perspective", "Exclusive pyramid landings", "Expert pilots", "Perfect for VIPs & special dates"], ar: ["منظور جوي فريد", "هبوط حصري عند الأهرامات", "طيارون خبراء", "مثالية لكبار الشخصيات والمناسبات"] },
//     audience: { en: "Tourists, VIPs, Investors, Romantic Dates", ar: "السياح، كبار الشخصيات، المستثمرون، المناسبات الرومانسية" },
//     duration: { en: "40 Min", ar: "40 دقيقة" },
//     image: "/flightSeeing/Screenshot (1181).png",
//     cta: { en: "Book Now", ar: "احجز الآن" },
//     stats: [
//       { label: { en: "Route", ar: "المسار" }, value: "Over Cairo & Pyramids" },
//       { label: { en: "Seats", ar: "المقاعد" }, value: "3 Passengers" },
//       { label: { en: "Duration", ar: "المدة" }, value: "40 Min" },
//       { label: { en: "Altitude", ar: "الارتفاع" }, value: "1000 FT" },
//       { label: { en: "Reservation", ar: "الحجز" }, value: "48 hrs. Before" }
//     ],
//     gallery: ["/flightSeeing/Screenshot (1181).png", "/flightSeeing/Screenshot (1182).png", "/flightSeeing/Screenshot (1183).png", "/flightSeeing/Screenshot (1184).png"]
//   },
//   {
//     key: "ads",
//     title: { en: "Aerial Advertising", ar: "إعلانات جوية" },
//     desc: { en: "Elevate your brand visibility with unique aerial displays.", ar: "ارتقِ برؤية علامتك التجارية مع عروضنا الجوية الفريدة." },
//     text: {
//       en: "Take your marketing campaigns to the sky. We offer premium aerial advertising services, including aircraft banners and paramotor campaigns, ensuring maximum visibility for your brand across major cities and events.",
//       ar: "ارتقِ بحملاتك التسويقية إلى السماء. نقدم خدمات إعلانية جوية متميزة، تشمل لافتات الطائرات وحملات الباراموتور، لضمان أقصى قدر من الرؤية لعلامتك التجارية عبر المدن والفعاليات الكبرى."
//     },
//     benefits: { en: ["High visibility", "Unique marketing angle", "Customizable campaigns", "Wide coverage area"], ar: ["رؤية عالية", "زاوية تسويقية فريدة", "حملات قابلة للتخصيص", "منطقة تغطية واسعة"] },
//     audience: { en: "Brands, Event Organizers, Marketers", ar: "العلامات التجارية، منظمو الفعاليات، المسوقون" },
//     duration: { en: "Campaign-based", ar: "حسب الحملة" },
//     image: "/ariel_advertisment/ariel_ad_1.png",
//     cta: { en: "Start Your Campaign", ar: "ابدأ حملتك" },
//     stats: [
//       { label: { en: "Visibility", ar: "الرؤية" }, value: "High" },
//       { label: { en: "Campaigns", ar: "حملات" }, value: "50+" },
//       { label: { en: "Locations", ar: "مواقع" }, value: "10+" },
//       { label: { en: "Impact", ar: "تأثير" }, value: "100%" }
//     ],
//     gallery: ["/ariel_advertisment/ariel_ad_1.png", "/ariel_advertisment/ariel_ad_2.png", "/ariel_advertisment/ariel_ad_3.png"]
//   },
//   {
//     key: "paramotor-advertising",
//     title: { en: "Paramotor Advertising", ar: "إعلانات الباراموتور" },
//     desc: { en: "Reach your audience with eye-catching paramotor displays.", ar: "صل إلى جمهورك من خلال عروض الباراموتور الجذابة." },
//     text: {
//       en: "Engage your audience with the thrill of paramotor advertising. Our specialized paramotor flights draw attention and provide a unique advertising medium for beaches, festivals, and large outdoor gatherings.",
//       ar: "اجذب انتباه جمهورك بإثارة إعلانات الباراموتور. رحلاتنا المتخصصة بالباراموتور تلفت الانتباه وتوفر وسيلة إعلانية فريدة للشواطئ، والمهرجانات، والتجمعات الكبيرة في الهواء الطلق."
//     },
//     benefits: { en: ["Engaging displays", "Perfect for outdoor events", "Unique brand exposure", "Flexible routing"], ar: ["عروض جذابة", "مثالية للفعاليات الخارجية", "تعرض فريد للعلامة التجارية", "مرونة في المسارات"] },
//     audience: { en: "Event Sponsors, Local Brands, Tourism Boards", ar: "رعاة الفعاليات، العلامات التجارية المحلية، هيئات السياحة" },
//     duration: { en: "Event-based", ar: "حسب الفعالية" },
//     image: "/paramotor/paramotor-1.png",
//     cta: { en: "Book Paramotor Campaign", ar: "احجز حملة باراموتور" },
//     stats: [
//       { label: { en: "Engagement", ar: "تفاعل" }, value: "High" },
//       { label: { en: "Speed", ar: "السرعة" }, value: "Low" },
//       { label: { en: "Visibility", ar: "رؤية" }, value: "Direct" },
//       { label: { en: "Impact", ar: "تأثير" }, value: "100%" }
//     ],
//     gallery: ["/paramotor/paramotor-1.png", "/paramotor/paramotor-2.png"]
//   },

//   // ---------------- Residency & Digital Nomad ----------------
//   {
//     key: "spain",
//     title: { en: "Spain Residency", ar: "الإقامة في إسبانيا" },
//     desc: { en: "Expert navigation through Spanish residency and legal pathways.", ar: "توجيه خبير عبر مسارات الإقامة والقوانين الإسبانية." },
//     text: {
//       en: `FlyVia guides you through Spanish residency with complete legal support. Services include document preparation, family inclusion, legal compliance checks, fast processing (20–40 business days), and step-by-step advisory.`,
//       ar: `FlyVia توجهك للحصول على الإقامة في إسبانيا بطريقة قانونية وسريعة. تشمل الخدمات تجهيز المستندات، متابعة قانونية، شمول العائلة، استلام الإقامة خلال 20–40 يوم عمل، واستشارة خطوة بخطوة.`
//     },
//     benefits: { en: ["Access to Spain & EU travel", "Legal security and compliance", "Educational opportunities for children", "Healthcare coverage"], ar: ["الوصول إلى إسبانيا والسفر داخل الاتحاد الأوروبي", "أمان قانوني والتزام", "فرص تعليمية للأطفال", "تغطية الرعاية الصحية"] },
//     audience: { en: "Families, investors, remote professionals", ar: "العائلات، المستثمرون، المحترفون عن بعد" },
//     duration: { en: "20–40 business days", ar: "20–40 يوم عمل" },
//     image: "/gallery-2.png",
//     cta: { en: "Start Your Residency", ar: "ابدأ إجراءات الإقامة" },
//     stats: [
//       { label: { en: "Success Rate", ar: "نسبة النجاح" }, value: "100%" },
//       { label: { en: "Families", ar: "عائلة" }, value: "150+" },
//       { label: { en: "Processing", ar: "مدة الإجراءات" }, value: "30d" },
//       { label: { en: "Lawyers", ar: "محامي" }, value: "10+" }
//     ],
//     gallery: ["/gallery-2.png", "/gallery-3.png", "/gallery-4.png", "/gallery-5.png"]
//   },
//   {
//     key: "nomad",
//     title: { en: "Digital Nomad Visa", ar: "فيزا الرحالة الرقمي" },
//     desc: { en: "Strategic support for remote professionals seeking life in Spain.", ar: "دعم استراتيجي للمهنيين عن بعد الساعين للحياة في إسبانيا." },
//     text: {
//       en: `FlyVia assists freelancers and remote workers to obtain a Digital Nomad Visa in Spain. Services include eligibility assessment, visa application preparation, legal guidance, tax compliance support, and post-arrival integration.`,
//       ar: `FlyVia تساعد المستقلين والعمال عن بعد للحصول على فيزا الرحالة الرقمي في إسبانيا. تشمل الخدمات تقييم الأهلية، تجهيز المستندات، الإرشاد القانوني، دعم الضرائب، ودعم ما بعد الوصول.`
//     },
//     benefits: { en: ["Work legally in Spain", "Live in Europe without employer restrictions", "Access to social services", "Fast-track guidance"], ar: ["العمل قانونيًا في إسبانيا", "العيش في أوروبا بدون قيود", "الوصول للخدمات الاجتماعية", "إرشاد سريع وشامل"] },
//     audience: { en: "Freelancers, remote workers", ar: "المستقلون، العمال عن بعد" },
//     duration: { en: "30–45 days", ar: "30–45 يوم" },
//     image: "/gallery-3.png",
//     cta: { en: "Check Eligibility", ar: "تحقق من أهليتك" },
//     stats: [
//       { label: { en: "Digital Nomads", ar: "رحالة رقمي" }, value: "200+" },
//       { label: { en: "Visa Approval", ar: "قبول الفيزا" }, value: "98%" },
//       { label: { en: "Community", ar: "مجتمع" }, value: "500+" },
//       { label: { en: "Cities", ar: "مدينة" }, value: "12+" }
//     ],
//     gallery: ["/gallery-3.png", "/gallery-4.png", "/gallery-5.png", "/gallery-6.png"]
//   },

//   // ---------------- Business Services ----------------
//   {
//     key: "formation",
//     title: { en: "Corporate Setup", ar: "تأسيس الشركات" },
//     desc: { en: "Complete business establishment and administrative support in Europe.", ar: "دعم كامل لتأسيس الأعمال والإدارة في أوروبا." },
//     text: {
//       en: `FlyVia helps launch companies in Spain or Europe from scratch. Services include company registration, accounting, tax setup, bank account opening, legal compliance, strategy guidance, and support for investors, startups, and SMEs.`,
//       ar: `FlyVia تساعد على تأسيس الشركات في إسبانيا أو أوروبا من البداية. تشمل الخدمات تسجيل الشركة، إعداد المحاسبة والضرائب، فتح حساب بنكي، الامتثال القانوني، الاستشارات الاستراتيجية، ودعم المستثمرين والمشاريع الناشئة.`
//     },
//     benefits: { en: ["Full A-to-Z company formation", "Compliance with Spanish and EU regulations", "Access to local business network", "Integration with residency applications"], ar: ["تأسيس كامل A-to-Z", "امتثال للوائح الإسبانية والأوروبية", "الوصول للشبكات المحلية", "دمج مع طلبات الإقامة عند الحاجة"] },
//     audience: { en: "Entrepreneurs, investors", ar: "رواد الأعمال، المستثمرون" },
//     duration: { en: "2–4 weeks", ar: "2–4 أسابيع" },
//     image: "/gallery-4.png",
//     cta: { en: "Start Your Company", ar: "ابدأ شركتك" },
//     stats: [
//       { label: { en: "Companies", ar: "شركة" }, value: "85+" },
//       { label: { en: "Growth", ar: "نمو" }, value: "40%" },
//       { label: { en: "Efficiency", ar: "كفاءة" }, value: "100%" },
//       { label: { en: "Setup Time", ar: "وقت التأسيس" }, value: "15d" }
//     ],
//     gallery: ["/gallery-4.png", "/gallery-5.png", "/gallery-6.png", "/gallery-7.png"]
//   },
//   {
//     key: "investment",
//     title: { en: "Investment Pathways", ar: "فرص الاستثمار" },
//     desc: { en: "Opportunities linked to residency or business expansion.", ar: "فرص مرتبطة بالإقامة أو التوسع التجاري." },
//     text: {
//       en: `FlyVia identifies investment opportunities in Spain and Europe, including real estate, commercial ventures, risk and compliance assessment, integration with residency planning, and market analysis.`,
//       ar: `FlyVia تحدد الفرص الاستثمارية في إسبانيا وأوروبا: الاستثمارات العقارية والتجارية، تقييم المخاطر، الامتثال القانوني، الدمج مع خطة الإقامة، وتحليل السوق.`
//     },
//     benefits: { en: ["Align investment with residency goals", "Mitigate financial and legal risks", "Expand business or portfolio in Europe"], ar: ["مواءمة الاستثمار مع الإقامة", "تقليل المخاطر المالية والقانونية", "توسيع الأعمال أو المحافظ الاستثمارية في أوروبا"] },
//     audience: { en: "Investors, business owners", ar: "المستثمرون، أصحاب الأعمال" },
//     duration: { en: "Ongoing until investment secured", ar: "مستمر حتى تأمين الاستثمار" },
//     image: "/gallery-5.png",
//     cta: { en: "Explore Investments", ar: "اكتشف الفرص" },
//     stats: [
//       { label: { en: "Investment", ar: "استثمارات" }, value: "€50M+" },
//       { label: { en: "Projects", ar: "مشروع" }, value: "30+" },
//       { label: { en: "ROI", ar: "عائد الاستثمار" }, value: "12%" },
//       { label: { en: "Partners", ar: "شريك" }, value: "20+" }
//     ],
//     gallery: ["/gallery-5.png", "/gallery-6.png", "/gallery-7.png", "/gallery-8.png"]
//   },

//   // ---------------- Relocation Services ----------------
//   {
//     key: "relocation",
//     title: { en: "Elite Relocation", ar: "الانتقال المتميز" },
//     desc: { en: "Dedicated management for a smooth transition into your new life.", ar: "إدارة مخصصة لانتقال سلس إلى حياتك الجديدة." },
//     text: {
//       en: `Complete relocation services to ensure a smooth move to Spain or Europe, including accommodation booking, airport reception, healthcare setup, guidance on local regulations, and a personal relocation manager.`,
//       ar: `خدمات انتقال كاملة لضمان انتقال سلس إلى إسبانيا أو أوروبا، تشمل حجز السكن، استقبال المطار، تجهيز التأمين الصحي، الإرشاد بشأن القوانين المحلية، وموظف متابعة شخصي.`
//     },
//     benefits: { en: ["Stress-free relocation", "Full legal and administrative support", "Settling-in guidance"], ar: ["انتقال بدون توتر", "دعم قانوني وإداري كامل", "إرشاد الاستقرار"] },
//     audience: { en: "Families, High-net-worth individuals", ar: "العائلات، الأفراد أصحاب الدخل العالي" },
//     duration: { en: "1–2 weeks for initial setup", ar: "1–2 أسابيع للإعداد الأولي" },
//     image: "/gallery-6.png",
//     cta: { en: "Plan Your Relocation", ar: "خطط انتقالك" },
//     stats: [
//       { label: { en: "Relocations", ar: "عملية انتقال" }, value: "300+" },
//       { label: { en: "Satisfaction", ar: "رضا العملاء" }, value: "100%" },
//       { label: { en: "Countries", ar: "دولة" }, value: "5" },
//       { label: { en: "Avg Time", ar: "متوسط الوقت" }, value: "10d" }
//     ],
//     gallery: ["/gallery-6.png", "/gallery-7.png", "/gallery-8.png", "/gallery-9.png"]
//   },
//   {
//     key: "education",
//     title: { en: "Education & Family", ar: "التعليم والعائلة" },
//     desc: { en: "Planning for family settlement and school placements.", ar: "تخطيط لاستقرار العائلة والالتحاق بالمدارس." },
//     text: {
//       en: `FlyVia helps families secure the best education for children and smooth integration into Europe, including school selection, enrollment, healthcare registration, and support for family settlement.`,
//       ar: `FlyVia تساعد العائلات في ضمان أفضل تعليم للأطفال وتسهيل اندماجهم في أوروبا، بما في ذلك اختيار المدارس، التسجيل، تجهيز الرعاية الصحية، ودعم استقرار العائلة.`
//     },
//     benefits: { en: ["Quality school enrollment", "Healthcare secured", "Smooth family integration"], ar: ["تسجيل الأطفال في مدارس عالية الجودة", "تأمين الرعاية الصحية", "دمج سلس للعائلة"] },
//     audience: { en: "Families relocating to Europe", ar: "العائلات التي تنتقل إلى أوروبا" },
//     duration: { en: "3–4 weeks", ar: "3–4 أسابيع" },
//     image: "/gallery-7.png",
//     cta: { en: "Secure Your Family's Future", ar: "أمن مستقبل عائلتك" },
//     stats: [
//       { label: { en: "Schools", ar: "مدرسة" }, value: "40+" },
//       { label: { en: "Students", ar: "طالب" }, value: "120+" },
//       { label: { en: "Admissions", ar: "قبولات" }, value: "100%" },
//       { label: { en: "Tutors", ar: "معلم" }, value: "25+" }
//     ],
//     gallery: ["/gallery-7.png", "/gallery-8.png", "/gallery-9.png", "/gallery-10.png"]
//   },
//   {
//     key: "property",
//     title: { en: "Luxury Real Estate", ar: "عقارات فاخرة" },
//     desc: { en: "Exclusive access to premium properties in the Mediterranean.", ar: "الوصول الحصري للعقارات المميزة في البحر المتوسط." },
//     text: {
//       en: `FlyVia provides access to handpicked luxury properties for investment or residence. Services include advisory support for safe acquisition and market guidance.`,
//       ar: `FlyVia توفر الوصول إلى عقارات مختارة للاستثمار أو السكن، مع تقديم استشارات لضمان عملية شراء آمنة وإرشادات السوق.`
//     },
//     benefits: { en: ["Exclusive property access", "Investment or residence opportunities", "Advisory for secure transactions"], ar: ["وصول حصري للعقارات", "فرص استثمارية أو سكنية", "استشارات لضمان سلامة المعاملة"] },
//     audience: { en: "Investors, High-net-worth individuals", ar: "المستثمرون، أصحاب الدخل العالي" },
//     duration: { en: "Varies depending on property", ar: "حسب العقار" },
//     image: "/gallery-8.png",
//     cta: { en: "View Properties", ar: "شاهد العقارات" },
//     stats: [
//       { label: { en: "Listings", ar: "عقار متاح" }, value: "500+" },
//       { label: { en: "Sales", ar: "مبيعات" }, value: "€200M" },
//       { label: { en: "Exclusives", ar: "عقارات حصرية" }, value: "45" },
//       { label: { en: "Agents", ar: "وكيل" }, value: "15" }
//     ],
//     gallery: ["/gallery-8.png", "/gallery-9.png", "/gallery-10.png", "/gallery-1.png"]
//   },
//   {
//     key: "concierge",
//     title: { en: "VIP Concierge", ar: "كونسيرج VIP" },
//     desc: { en: "Lifestyle management and bespoke arrangements for the elite.", ar: "إدارة أسلوب الحياة وترتيبات مخصصة للنخبة." },
//     text: {
//       en: `From private appointments to full lifestyle management, FlyVia concierge services include event and dining bookings, personalized itinerary planning, and dedicated support to meet exclusive client needs.`,
//       ar: `من المواعيد الخاصة إلى إدارة أسلوب الحياة الكامل، تشمل خدمات كونسيرج FlyVia حجز الفعاليات والمطاعم، تخطيط جدول شخصي، ودعم كامل لتلبية احتياجات العملاء الحصرية.`
//     },
//     benefits: { en: ["Tailored lifestyle management", "VIP support", "Full European integration"], ar: ["إدارة أسلوب الحياة حسب الطلب", "دعم VIP", "دمج كامل في أوروبا"] },
//     audience: { en: "VIPs, High-net-worth clients", ar: "كبار الشخصيات، العملاء ذوي الدخل العالي" },
//     duration: { en: "Ongoing", ar: "مستمر حسب الحاجة" },
//     image: "/gallery-10.png",
//     cta: { en: "Request Concierge", ar: "اطلب كونسيرج" },
//     stats: [
//       { label: { en: "Requests", ar: "طلب" }, value: "1200+" },
//       { label: { en: "Members", ar: "عضو" }, value: "100" },
//       { label: { en: "Partners", ar: "شريك" }, value: "250+" },
//       { label: { en: "Cities", ar: "مدينة" }, value: "20+" }
//     ],
//     gallery: ["/gallery-10.png", "/gallery-1.png", "/gallery-2.png", "/gallery-3.png"]
//   }
// ];

// export default function ServiceDetails() {
//   const { id } = useParams();
//   const { currentLang, isInitialized } = useLanguage();
//   const navigate = useNavigate();
//   const containerRef = useRef(null);
//   const langKey = currentLang === 'ar' ? 'ar' : 'en';
//   const isAR = langKey === 'ar';

//   const service = useMemo(() => flyviaServicesFullBilingual.find(s => s.key === id) || flyviaServicesFullBilingual[0], [id]);

//   const isAviation = service?.key === 'privateJet' || service?.key === 'emptyLeg' || service?.key === 'commercial' || service?.key === 'vipTerminal';

//   const isPremium = useMemo(() => {
//     const titleEn = service?.title?.en?.toLowerCase() || '';
//     const key = service?.key?.toLowerCase() || '';
//     return titleEn.includes('vip') || titleEn.includes('luxury') || titleEn.includes('private') || key.includes('vip') || isAviation;
//   }, [service, isAviation]);

//   const theme = {
//     bg: isPremium ? '#07111f' : '#fff',
//     text: isPremium ? '#fff' : '#07111f',
//     accent: isPremium ? '#d4af37' : '#ae0001',
//     cardBg: isPremium ? 'rgba(255,255,255,0.03)' : '#f8fafc',
//     border: isPremium ? 'rgba(255,255,255,0.1)' : '#f1f5f9',
//     goldGradient: 'linear-gradient(135deg, #d4af37 0%, #f9e8af 50%, #d4af37 100%)'
//   };

//   useEffect(() => {
//     if (!isInitialized) return;
//     const ctx = gsap.context(() => {
//       gsap.from('.reveal-up', { y: 40, opacity: 0, stagger: 0.1, duration: 1, ease: 'power3.out' });
//     }, containerRef);
//     window.scrollTo(0, 0);
//     return () => ctx.revert();
//   }, [isInitialized, id]);

//   if (!isInitialized || !service) return null;

//   return (
//     <div className="service-details-bilingual" ref={containerRef} dir={isAR ? 'rtl' : 'ltr'}>
//       <SEO
//         title={service.title[langKey]}
//         description={service.desc[langKey]}
//         keywords={`${service.title.en}, ${service.key}, FlyVia ${service.title.en}, Europe ${service.title.en}`}
//       />

//       <style>{`
//         .service-details-bilingual {
//           background: ${theme.bg};
//           color: ${theme.text};
//           min-height: 100vh;
//           font-family: var(--font-primary);
//           overflow-x: hidden;
//         }

//         .page-banner {
//           position: relative;
//           height: 55vh;
//           min-height: 500px;
//           background: linear-gradient(rgba(7, 17, 31, 0.75), rgba(7, 17, 31, 0.85)),
//                       url(${service.image});
//           background-size: cover;
//           background-position: center;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           text-align: center;
//           color: #fff;
//           clip-path: polygon(0 0, 100% 0, 100% 92%, 50% 100%, 0 92%);
//           margin-bottom: 100px;
//         }

//         .banner-content h1 {
//           font-family: var(--font-heading);
//           font-size: clamp(38px, 7vw, 84px);
//           font-weight: 800;
//           margin-bottom: 25px;
//           text-transform: uppercase;
//           letter-spacing: -1px;
//           line-height: 1;
//         }

//         .breadcrumbs {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 15px;
//           font-family: var(--font-secondary);
//           font-size: 14px;
//           text-transform: uppercase;
//           letter-spacing: 0.15em;
//           font-weight: 700;
//         }
//         .breadcrumbs a { color: #fff; text-decoration: none; opacity: 0.6; transition: 0.3s; }
//         .breadcrumbs a:hover { opacity: 1; }
//         .breadcrumbs span { color: ${theme.accent}; }

//         /* Refined About Section */
//         .refined-about-section {
//           padding: 10px 0;
//           background: ${isAviation ? '#07111f' : '#fcfcfd'};
//           color: ${isAviation ? '#fff' : '#07111f'};
//           position: relative;
//         }
//         .about-visual-container {
//           position: relative;
//           border-radius: 24px;
//           overflow: hidden;
//           box-shadow: 0 40px 80px rgba(0,0,0,0.25);
//         }
//         .about-visual-container img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transition: 1s var(--ease);
//         }
//         .about-decorative-glow {
//           position: absolute;
//           width: 300px; height: 300px;
//           background: ${theme.accent};
//           filter: blur(150px);
//           opacity: 0.15;
//           z-index: -1;
//           ${isAR ? 'right: -100px;' : 'left: -100px;'}
//           top: -50px;
//         }

//         .about-content-refined h2 {
//           font-family: var(--font-heading);
//           font-size: clamp(32px, 4vw, 56px);
//           margin-bottom: 30px;
//           font-weight: 800;
//           line-height: 1.1;
//         }
//         .about-content-refined h2 span {
//           display: inline-block;
//           background: ${theme.accent};
//           color: ${isAviation ? '#000' : '#fff'} !important;
//           padding: 0 15px;
//           margin-left: 5px;
//         }
//         .about-content-refined p {
//           font-size: 18px;
//           line-height: 1.8;
//           opacity: 0.8;
//           margin-bottom: 40px;
//         }

//         /* Stats Section */
//         .stats-section-final {
//           padding: 120px 0;
//           background: linear-gradient(rgba(7, 17, 31, 0.92), rgba(7, 17, 31, 0.92)),
//                       url(${service.image});
//           background-size: cover;
//           background-position: center;
//           background-attachment: fixed;
//           color: #fff;
//           text-align: center;
//         }
//         .stat-item-refined {
//           padding: 30px;
//           border-right: 1px solid rgba(255,255,255,0.1);
//         }
//         .stat-item-refined:last-child { border: none; }
//         .stat-value-refined {
//           font-family: var(--font-heading);
//           font-size: clamp(40px, 5vw, 64px);
//           font-weight: 800;
//           display: block;
//           margin-bottom: 10px;
//         }
//         .stat-plus { color: ${theme.accent}; margin-left: 5px; }
//         .stat-label-refined {
//           font-family: var(--font-secondary);
//           font-size: 14px;
//           text-transform: uppercase;
//           letter-spacing: 0.2em;
//           opacity: 0.6;
//         }

//         /* Gallery Section */
//         .gallery-section-final {
//           padding: 120px 0;
//           background: ${theme.bg};
//         }
//         .gallery-header { text-align: center; margin-bottom: 60px; }
//         .gallery-eyebrow {
//           color: ${theme.accent};
//           font-family: var(--font-secondary);
//           font-size: 14px;
//           text-transform: uppercase;
//           letter-spacing: 0.3em;
//           display: block;
//           margin-bottom: 15px;
//         }
//         .gallery-title {
//           font-family: var(--font-heading);
//           font-size: 42px;
//           font-weight: 800;
//           color: ${theme.text};
//         }
//         .gallery-swiper-container {
//           padding: 20px 0 60px;
//         }
//         .gallery-slide-img {
//           width: 100%;
//           aspect-ratio: 16/9;
//           object-fit: cover;
//           border-radius: 20px;
//           filter: grayscale(0.8) contrast(1.2);
//           transition: 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
//         }
//         .swiper-slide-active .gallery-slide-img {
//           filter: grayscale(0) contrast(1);
//           transform: scale(1.08);
//           box-shadow: 0 30px 60px rgba(0,0,0,0.4);
//         }

//         .gold-accent-text {
//           color: #d4af37 !important;
//           font-weight: 800;
//           text-shadow: 0 0 10px rgba(212, 175, 55, 0.3);
//           display: inline;
//         }

//         .premium-border {
//           position: relative;
//         }
//         .premium-border::after {
//           content: '';
//           position: absolute;
//           bottom: 0; left: 0;
//           width: 60px; height: 3px;
//           background: ${theme.accent};
//         }

//         .benefit-card-final {
//           background: ${theme.cardBg};
//           border: 1px solid ${theme.border};
//           padding: 35px;
//           border-radius: 20px;
//           height: 100%;
//           transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
//         }
//         .benefit-card-final:hover {
//           transform: translateY(-10px);
//           border-color: ${theme.accent};
//           box-shadow: 0 20px 40px rgba(0,0,0,0.08);
//         }

//         .sidebar-card-final {
//           background: ${isAviation ? 'rgba(255,255,255,0.05)' : '#07111f'};
//           color: #fff;
//           padding: 45px;
//           border-radius: 24px;
//           position: sticky; top: 120px;
//           box-shadow: 0 30px 60px rgba(0,0,0,0.15);
//         }

//         .info-pill-final {
//           display: flex;
//           align-items: center;
//           gap: 15px;
//           padding: 15px 0;
//           border-bottom: 1px solid rgba(255,255,255,0.1);
//         }
//         .info-pill-final:last-child { border: none; }
//         .pill-icon { font-size: 20px; color: ${theme.accent}; }
//         .pill-label { font-size: 12px; text-transform: uppercase; opacity: 0.5; display: block; margin-bottom: 2px; }
//         .pill-value { font-size: 15px; font-weight: 700; }

//         .cta-btn-refined {
//           background: ${theme.accent};
//           color: ${isAviation && theme.accent === '#d4af37' ? '#000' : '#fff'};
//           border: none;
//           padding: 18px 40px;
//           border-radius: 50px;
//           font-weight: 800;
//           text-transform: uppercase;
//           font-family: var(--font-secondary);
//           font-size: 13px;
//           letter-spacing: 0.15em;
//           transition: 0.4s;
//           display: inline-flex; align-items: center; gap: 15px;
//         }
//         .cta-btn-refined:hover { transform: translateY(-5px); box-shadow: 0 15px 30px ${theme.accent}44; }

//         @media (max-width: 991px) {
//           .page-banner { height: 45vh; margin-bottom: 50px; }
//           .sidebar-card-final { position: static; margin-top: 50px; }
//           .stat-item-refined { border: none; border-bottom: 1px solid rgba(255,255,255,0.1); }
//         }
//       `}</style>

//       <section className="page-banner">
//         <Container className="banner-content">
//           <h1 className="reveal-up">{service.title[langKey]}</h1>
//           <div className="breadcrumbs reveal-up">
//             <Link to="/">{isAR ? 'الرئيسية' : 'Home'}</Link>
//             {isAR ? <FaArrowLeft size={12} /> : <FaArrowRight size={12} />}
//             <Link to="/ourservicepage">{isAR ? 'خدماتنا' : 'Services'}</Link>
//             {isAR ? <FaArrowLeft size={12} /> : <FaArrowRight size={12} />}
//             <span>{service.title[langKey]}</span>
//           </div>
//         </Container>
//       </section>

//       <section className="refined-about-section">
//         <Container>
//           <Row className="align-items-center gy-5">
//             <Col lg={6} className={isAR ? 'order-lg-2' : ''}>
//               <div className="about-visual-container reveal-up">
//                 <div className="about-decorative-glow"></div>
//                 <img src={service.image} alt={service.title[langKey]} />
//               </div>
//             </Col>
//             <Col lg={6} className={isAR ? 'order-lg-1' : ''}>
//               <div className="about-content-refined reveal-up">
//                 <h2>{isAR ? 'عن' : 'About'} <span className={isPremium ? 'gold-accent-text' : ''}>{service.title[langKey]}</span></h2>
//                 <p>{service.text[langKey]}</p>
//                 <button className="cta-btn-refined" onClick={() => navigate('/#contact')}>
//                   <FaPlane /> {service.cta[langKey]}
//                 </button>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       {service.stats && (
//         <section className="stats-section-final">
//           <Container>
//             <h6 className="gallery-eyebrow reveal-up" style={{ color: '#fff', opacity: 0.7 }}>{service.title[langKey]}</h6>
//             <h2 className="gallery-title reveal-up mb-5" style={{ color: '#fff' }}>{isAR ? 'بالأرقام' : 'In Numbers'}</h2>
//             <Row className="reveal-up">
//               {service.stats.map((stat, i) => (
//                 <Col md={3} sm={6} key={i}>
//                   <div className="stat-item-refined">
//                     <span className="stat-value-refined">
//                       {stat.value.includes('+') ? stat.value.replace('+', '') : stat.value}
//                       {stat.value.includes('+') && <span className="stat-plus">+</span>}
//                     </span>
//                     <span className="stat-label-refined">{stat.label[langKey]}</span>
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </Container>
//         </section>
//       )}

//       <Container className="py-24">
//         <Row className="gy-5">
//           <Col lg={8}>
//             <div className="reveal-up">
//               <h3 className="mb-5 mt-3" style={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: '36px' }}>{isAR ? 'المزايا الأساسية' : 'Key Benefits'}</h3>
//               <Row className="gy-4">
//                 {service.benefits[langKey].map((b, i) => (
//                   <Col md={6} key={i}>
//                     <div className="benefit-card-final">
//                       <FaCheckCircle color={theme.accent} size={24} className="mb-3" />
//                       <h4 style={{ fontSize: '18px', fontWeight: 800, marginBottom: '10px' }}>{b}</h4>
//                       <p style={{ fontSize: '14px', opacity: 0.6, margin: 0 }}>
//                         {isAR ? 'ضمان أعلى معايير الجودة والاحترافية في التنفيذ.' : 'Ensuring the highest standards of quality and professional execution.'}
//                       </p>
//                     </div>
//                   </Col>
//                 ))}
//               </Row>
//             </div>
//           </Col>

//           <Col lg={4}>
//             <div className="sidebar-card-final reveal-up">
//               <h3 className="mb-4" style={{ fontFamily: 'var(--font-heading)', fontSize: '24px' }}>{isAR ? 'معلومات الخدمة' : 'Service Information'}</h3>

//               <div className="info-pill-final">
//                 <div className="pill-icon"><FaUserFriends /></div>
//                 <div>
//                   <span className="pill-label">{isAR ? 'الجمهور المستهدف' : 'Target Audience'}</span>
//                   <span className="pill-value">{service.audience[langKey]}</span>
//                 </div>
//               </div>

//               <div className="info-pill-final">
//                 <div className="pill-icon"><FaRegClock /></div>
//                 <div>
//                   <span className="pill-label">{isAR ? 'المدة المتوقعة' : 'Expected Duration'}</span>
//                   <span className="pill-value">{service.duration[langKey]}</span>
//                 </div>
//               </div>

//               <div className="info-pill-final">
//                 <div className="pill-icon"><FaAward /></div>
//                 <div>
//                   <span className="pill-label">{isAR ? 'الجودة' : 'Quality'}</span>
//                   <span className="pill-value">{isAR ? 'معايير عالمية' : 'Global Standards'}</span>
//                 </div>
//               </div>

//               <div className="info-pill-final">
//                 <div className="pill-icon"><FaUserCheck /></div>
//                 <div>
//                   <span className="pill-label">{isAR ? 'الخصوصية' : 'Privacy'}</span>
//                   <span className="pill-value">{isAR ? 'سرية تامة' : 'Full Discretion'}</span>
//                 </div>
//               </div>

//               <div className="mt-5 pt-4 border-top text-center" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
//                 <p className="small opacity-50 mb-3">{isAR ? 'أو تواصل معنا مباشرة' : 'Or contact us directly'}</p>
//                 <a href="tel:+34614909102" className="text-white text-decoration-none h4 d-block fw-bold">+34 614 909 102</a>
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>

//       {service.gallery && (
//         <section className="gallery-section-final">
//           <div className="gallery-header reveal-up">
//             <span className="gallery-eyebrow">Gallery</span>
//             <h2 className="gallery-title">{service.title[langKey]}</h2>
//           </div>
//           <div className="gallery-swiper-container reveal-up">
//             <Swiper
//               modules={[Pagination, Navigation, Autoplay]}
//               spaceBetween={30}
//               slidesPerView={1.2}
//               centeredSlides={true}
//               loop={true}
//               autoplay={{ delay: 3500 }}
//               pagination={{ clickable: true }}
//               navigation={true}
//               breakpoints={{
//                 768: { slidesPerView: 2.2 },
//                 1024: { slidesPerView: 2.5 }
//               }}
//               className="gallery-swiper"
//             >
//               {service.gallery.map((img, i) => (
//                 <SwiperSlide key={i}>
//                   <img src={img} alt={`Gallery ${i}`} className="gallery-slide-img" />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>
//         </section>
//       )}

//       <div className="fixed inset-0 w-full h-full pointer-events-none" style={{ zIndex: 0 }}>
//         <Particles
//           particleColors={isPremium ? ["#ffffff", "#d4af37"] : ["#2c3b5b", "#ae0001"]}
//           particleCount={250}
//           particleSpread={12}
//           speed={0.12}
//           particleBaseSize={120}
//           moveParticlesOnHover={true}
//           alphaParticles={true}
//           disableRotation={false}
//           pixelRatio={1}
//         />
//       </div>
//     </div>
//   );
// }

import gsap from "gsap";
import { useEffect, useMemo, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  FaArrowLeft,
  FaArrowRight,
  FaAward,
  FaCheckCircle,
  FaPlane,
  FaRegClock,
  FaUserCheck,
  FaUserFriends,
} from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../component/LanguageProvider";
import SEO from "../component/SEO";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Particles from "../component/Particles";

const serviceAliases = {
  privateJet: "jet",
  privatejet: "jet",
  tours: "flight-sightseeing-tour",
  sightseeing: "flight-sightseeing-tour",
  "flight-crew-training": "flightCrewTraining",
  "almaza-vip-terminal": "almaza-vip-terminal",
  almazaVipTerminal: "vipTerminal",
  spain: "residency",
};

const aviationKeys = [
  "jet",
  "emptyLeg",
  "commercial",
  "vipTerminal",
  "medEvac",
  "cargo",
  "ads",
  "paramotor-advertising",
  "flight-sightseeing-tour",
  "flightCrewTraining",
];

const flyviaServicesFullBilingual = [
  {
    key: "jet",
    title: { en: "Private Jet Charter", ar: "تأجير الطائرات الخاصة" },
    desc: {
      en: "Exclusive private jet travel with luxury aircraft, speed, privacy, and concierge-level service.",
      ar: "رحلات طيران خاصة بطائرات فاخرة تجمع بين السرعة والخصوصية وخدمة كونسيرج مخصصة.",
    },
    text: {
      en: "Swift Jet’s Private Jet Charter delivers an exclusive travel experience built around privacy, comfort, and speed. The service offers access to a premium fleet including Cessna Citation 680, Global 6000, Global 7500, Gulfstream 400, Falcon 20, and Beechcraft King Air 350. It is designed for clients who need personalized travel, refined onboard comfort, advanced technology, and seamless service across the Middle East, Europe, and Africa.",
      ar: "تقدم Swift Jet خدمة تأجير الطائرات الخاصة لتجربة سفر حصرية مبنية على الخصوصية والراحة والسرعة. تشمل الخدمة أسطولًا فاخرًا يضم Cessna Citation 680 وGlobal 6000 وGlobal 7500 وGulfstream 400 وFalcon 20 وBeechcraft King Air 350. الخدمة مناسبة للعملاء الذين يحتاجون إلى سفر مخصص وراحة عالية وتقنيات متقدمة وتجربة سلسة داخل الشرق الأوسط وأوروبا وأفريقيا.",
    },
    benefits: {
      en: [
        "Exclusive private aircraft fleet",
        "Concierge-level personalized service",
        "Fast and efficient travel",
        "Luxury comfort and advanced onboard technology",
      ],
      ar: [
        "أسطول خاص فاخر",
        "خدمة شخصية بمستوى كونسيرج",
        "سفر سريع وفعال",
        "راحة فاخرة وتقنيات متقدمة على متن الطائرة",
      ],
    },
    audience: {
      en: "VIPs, executives, families, luxury travelers",
      ar: "كبار الشخصيات، رجال الأعمال، العائلات، محبو السفر الفاخر",
    },
    duration: { en: "On-demand / route-based", ar: "حسب الطلب ومسار الرحلة" },
    image: "/jet.jpeg",
    cta: { en: "Book Your Jet Now", ar: "احجز طائرتك الآن" },
    stats: [
      { label: { en: "Trips", ar: "رحلة" }, value: "1200+" },
      { label: { en: "Happy Customers", ar: "عميل سعيد" }, value: "400+" },
      { label: { en: "Flying Hours", ar: "ساعة طيران" }, value: "9000+" },
      { label: { en: "Destinations", ar: "وجهة" }, value: "100+" },
    ],
    gallery: [
      "/Gemini_Generated_Image_4pblo04pblo04pbl.png",
      "/6.png",
      "/advertising.jpeg",
    ],
  },
  {
    key: "emptyLeg",
    title: { en: "Empty Leg Flights", ar: "رحلات Empty Leg" },
    desc: {
      en: "Reduced-rate private jet opportunities on repositioning aircraft across Europe, the Middle East, and Africa.",
      ar: "فرص سفر بطائرات خاصة بأسعار أقل على رحلات إعادة التموضع داخل أوروبا والشرق الأوسط وأفريقيا.",
    },
    text: {
      en: "Empty Leg Flights are smart private aviation opportunities offered when an aircraft would otherwise fly empty. Swift Jet Aviation lists one-way private jet options across Europe, the Middle East, and Africa with flexible routing support, aircraft guidance, airport options, baggage support, and last-minute charter alternatives. Availability is refreshed regularly to keep offers accurate.",
      ar: "رحلات Empty Leg هي فرص ذكية للسفر بطائرات خاصة عندما تكون الطائرة في طريقها لإعادة التموضع بدون ركاب. توفر Swift Jet Aviation خيارات رحلات خاصة باتجاه واحد داخل أوروبا والشرق الأوسط وأفريقيا مع دعم في اختيار الطائرة والمسار والمطار والأمتعة والحلول السريعة عند تغير الجداول.",
    },
    benefits: {
      en: [
        "Lower-cost private jet travel",
        "One-way private jet opportunities",
        "Flexible route support",
        "Aircraft and baggage guidance",
      ],
      ar: [
        "سفر خاص بتكلفة أقل",
        "فرص رحلات خاصة باتجاه واحد",
        "دعم مرن للمسارات",
        "إرشاد في اختيار الطائرة والأمتعة",
      ],
    },
    audience: {
      en: "Flexible private jet travelers",
      ar: "المسافرون المرنون الباحثون عن طيران خاص",
    },
    duration: {
      en: "Depends on available schedule",
      ar: "حسب جدول الرحلات المتاحة",
    },
    image: "/4460dff2-298b-4bd6-aa84-58ad35651c2b.png",
    cta: { en: "Check Available Empty Legs", ar: "تحقق من الرحلات المتاحة" },
    stats: [
      { label: { en: "Availability", ar: "التوافر" }, value: "Live" },
      { label: { en: "Regions", ar: "مناطق" }, value: "3+" },
      { label: { en: "Support", ar: "دعم" }, value: "24/7" },
      { label: { en: "Savings", ar: "توفير" }, value: "High" },
    ],
    gallery: ["/4460dff2-298b-4bd6-aa84-58ad35651c2b.png"],
  },
  {
    key: "commercial",
    title: { en: "Commercial Flight", ar: "الرحلات التجارية" },
    desc: {
      en: "Comfortable and efficient regional commercial flight solutions to Egypt’s unique destinations.",
      ar: "حلول رحلات تجارية مريحة وفعالة إلى وجهات مصرية مميزة.",
    },
    text: {
      en: "Swift Jet’s Commercial Flight service combines efficiency, comfort, reliability, and attentive service. The service connects travelers to distinctive destinations such as Siwa, Ras Banas, Luxor, Red Sea, Abu Simbel, El Kharga, Hurghada, Saint Catherine, and Makkah. The fleet includes aircraft such as C295 Casa, Beechcraft, ATR72-600, Dash8-Q300, and CRJ900 NextGen.",
      ar: "تجمع خدمة الرحلات التجارية من Swift Jet بين الكفاءة والراحة والالتزام في المواعيد والخدمة الدقيقة. تربط الخدمة المسافرين بوجهات مميزة مثل سيوة، رأس بناس، الأقصر، البحر الأحمر، أبو سمبل، الخارجة، الغردقة، سانت كاترين، ومكة. ويشمل الأسطول طائرات مثل C295 Casa وBeechcraft وATR72-600 وDash8-Q300 وCRJ900 NextGen.",
    },
    benefits: {
      en: [
        "Regional and international destination access",
        "Reliable scheduling",
        "Comfort-focused travel",
        "Diverse aircraft fleet",
      ],
      ar: [
        "وصول لوجهات محلية ودولية",
        "التزام في الجداول",
        "رحلة مريحة",
        "أسطول متنوع",
      ],
    },
    audience: {
      en: "Business travelers, groups, regional travelers",
      ar: "رجال الأعمال، المجموعات، المسافرون بين الوجهات الإقليمية",
    },
    duration: { en: "Route-based", ar: "حسب مسار الرحلة" },
    image: "/commercial.jpeg",
    cta: { en: "Book Your Flight Now", ar: "احجز رحلتك الآن" },
    stats: [
      { label: { en: "Trips", ar: "رحلة" }, value: "2500+" },
      { label: { en: "Happy Customers", ar: "عميل سعيد" }, value: "5000+" },
      { label: { en: "Flying Hours", ar: "ساعة طيران" }, value: "15000+" },
      { label: { en: "Destinations", ar: "وجهة" }, value: "20+" },
    ],
    gallery: [
      "/commercial.jpeg",
      "https://swiftjetaviation.com/wp-content/uploads/2024/03/steptodown.com127589.jpg",
      "https://swiftjetaviation.com/wp-content/uploads/2024/03/158695538773759.jpeg",
      "https://swiftjetaviation.com/wp-content/uploads/2024/03/SwiftJet-Company-Profile-1_Page_068_Image_0002-scaled.jpg",
    ],
  },
  {
    key: "vipTerminal",
    title: { en: "Almaza VIP Terminal", ar: "صالة ألماظة VIP" },
    desc: {
      en: "Exclusive private jet departure and arrival experience with privacy, easy access, and discreet service.",
      ar: "تجربة مغادرة ووصول حصرية للطائرات الخاصة مع خصوصية وسهولة وصول وخدمة راقية.",
    },
    text: {
      en: "Swift Jet’s Almaza VIP Terminal elevates the private jet experience with exclusive departure and arrival services. The terminal offers stronger privacy compared to Cairo Airport Hall 4, easy road access, reduced traffic, and a discreet celebrity-friendly environment designed specifically for private jet flights.",
      ar: "ترتقي صالة ألماظة VIP من Swift Jet بتجربة الطيران الخاص من خلال خدمات مغادرة ووصول حصرية. توفر الصالة خصوصية أعلى مقارنة بصالة 4 في مطار القاهرة، مع سهولة وصول من الطريق الرئيسي وتقليل للزحام وبيئة راقية ومناسبة لكبار الشخصيات ومصممة خصيصًا لرحلات الطائرات الخاصة.",
    },
    benefits: {
      en: [
        "Private jet-focused terminal",
        "High privacy",
        "Easy road access",
        "Discreet VIP environment",
      ],
      ar: [
        "صالة مخصصة للطائرات الخاصة",
        "خصوصية عالية",
        "سهولة وصول من الطريق",
        "بيئة VIP هادئة وسرية",
      ],
    },
    audience: {
      en: "Private jet passengers, VIPs, celebrities, executives",
      ar: "ركاب الطائرات الخاصة، كبار الشخصيات، المشاهير، رجال الأعمال",
    },
    duration: {
      en: "Per departure or arrival",
      ar: "حسب رحلة المغادرة أو الوصول",
    },
    image: "/almaza-vip-terminal.jpeg",
    cta: { en: "Reserve VIP Terminal", ar: "احجز صالة VIP" },
    stats: [
      { label: { en: "Privacy", ar: "خصوصية" }, value: "100%" },
      { label: { en: "Access", ar: "سهولة الوصول" }, value: "Fast" },
      { label: { en: "Service", ar: "الخدمة" }, value: "VIP" },
      { label: { en: "Terminal", ar: "الصالة" }, value: "Almaza" },
    ],
    gallery: [
      "/gallery-9.png",
      "/almaza-vip-terminal.jpeg",
      "/almaza-vip-terminal.jpeg",
      "https://swiftjetaviation.com/wp-content/uploads/2024/03/WhatsApp-Image-2024-03-02-at-12.36.07-AM-1.jpeg",
    ],
  },
  {
    key: "medEvac",
    title: { en: "Medical Evacuation", ar: "الإخلاء الطبي" },
    desc: {
      en: "Urgent air medical transport with equipped aircraft, medical professionals, and global response support.",
      ar: "نقل طبي جوي عاجل بطائرات مجهزة وطاقم طبي متخصص ودعم استجابة عالمي.",
    },
    text: {
      en: "Swift Jet’s Medical Evacuation service provides urgent, compassionate air medical transport for patients who need care during transfer to or from medical facilities. The service is built for critical situations where speed, safety, coordination, and specialist support matter most.",
      ar: "توفر خدمة الإخلاء الطبي من Swift Jet نقلًا طبيًا جويًا عاجلًا وإنسانيًا للحالات التي تحتاج إلى رعاية أثناء الانتقال من أو إلى المنشآت الطبية. الخدمة مصممة للحالات الحرجة التي تحتاج إلى سرعة وأمان وتنسيق ودعم متخصص.",
    },
    benefits: {
      en: [
        "Rapid medical response",
        "Equipped air ambulance support",
        "Medical coordination",
        "Urgent case handling",
      ],
      ar: [
        "استجابة طبية سريعة",
        "دعم إسعاف جوي مجهز",
        "تنسيق طبي",
        "تعامل مع الحالات العاجلة",
      ],
    },
    audience: {
      en: "Patients, hospitals, families, medical coordinators",
      ar: "المرضى، المستشفيات، العائلات، منسقو الرعاية الطبية",
    },
    duration: { en: "Urgent / case-based", ar: "عاجلة حسب الحالة" },
    image: "/medical.jpeg",
    cta: {
      en: "Get Medical Evacuation Quotation",
      ar: "اطلب عرض الإخلاء الطبي",
    },
    stats: [
      { label: { en: "Missions", ar: "مهام" }, value: "550+" },
      { label: { en: "Support", ar: "دعم" }, value: "24/7" },
      { label: { en: "Response", ar: "استجابة" }, value: "Fast" },
      { label: { en: "Care", ar: "رعاية" }, value: "High" },
    ],
    gallery: ["/medical.jpeg", "/medical.jpeg"],
  },
  {
    key: "cargo",
    title: { en: "Cargo", ar: "الشحن الجوي" },
    desc: {
      en: "Secure cargo aviation solutions for general goods, perishables, live animals, pharmaceuticals, and dangerous goods.",
      ar: "حلول شحن جوي آمنة للبضائع العامة والمواد القابلة للتلف والحيوانات الحية والأدوية والمواد الخطرة.",
    },
    text: {
      en: "Swift Jet’s Cargo service delivers secure and reliable air cargo transportation with a fleet including C295 Casa, IL-76 MF, and C130. The service handles general cargo, perishables, live animals, pharmaceuticals, and dangerous goods including explosives, gases, toxic substances, flammable materials, radioactive materials, oxidizing substances, and corrosive substances. It focuses on safety, efficiency, customized logistics, global reach, and 24/7 support.",
      ar: "تقدم خدمة الشحن الجوي من Swift Jet نقلًا آمنًا وموثوقًا للبضائع عبر أسطول يضم C295 Casa وIL-76 MF وC130. تتعامل الخدمة مع البضائع العامة والمواد القابلة للتلف والحيوانات الحية والأدوية والمواد الخطرة مثل المتفجرات والغازات والمواد السامة والقابلة للاشتعال والمشعة والمؤكسدة والكاوية. وتركز على السلامة والكفاءة والحلول المخصصة والوصول العالمي والدعم على مدار الساعة.",
    },
    benefits: {
      en: [
        "General and special cargo handling",
        "Dangerous goods expertise",
        "Global reach",
        "24/7 logistics support",
      ],
      ar: [
        "التعامل مع البضائع العامة والخاصة",
        "خبرة في المواد الخطرة",
        "وصول عالمي",
        "دعم لوجستي 24/7",
      ],
    },
    audience: {
      en: "Logistics teams, companies, exporters, medical suppliers",
      ar: "فرق اللوجستيات، الشركات، المصدرون، مورّدو القطاع الطبي",
    },
    duration: { en: "Shipment-based", ar: "حسب الشحنة" },
    image: "/cargo.jpeg",
    cta: { en: "Get Your Cargo Shipped Now", ar: "ابدأ شحن بضائعك الآن" },
    stats: [
      { label: { en: "Trips", ar: "رحلة" }, value: "800+" },
      { label: { en: "Happy Customers", ar: "عميل سعيد" }, value: "500+" },
      { label: { en: "Flying Hours", ar: "ساعة طيران" }, value: "700+" },
      { label: { en: "Destinations", ar: "وجهة" }, value: "4+" },
    ],
    gallery: [
      "/cargo.jpeg",
      "https://swiftjetaviation.com/wp-content/uploads/2024/03/steptodown.com209472.jpg",
      "https://swiftjetaviation.com/wp-content/uploads/2024/03/Untitled-2-min-1024x576.png",
      "	https://swiftjetaviation.com/wp-content/uploads/2024/03/11236875646_2a8d59bebe_w.jpg",
    ],
  },
  {
    key: "ads",
    title: { en: "Aerial Advertising", ar: "الإعلانات الجوية" },
    desc: {
      en: "Eye-catching aerial campaigns using helicopters and aircraft to put your brand in the sky.",
      ar: "حملات إعلانية جوية ملفتة باستخدام المروحيات والطائرات لرفع ظهور علامتك في السماء.",
    },
    text: {
      en: "Swift Jet’s Aerial Advertising service uses helicopters and aircraft to take brand messages into the sky. It is designed for campaigns that need high visibility, public attention, and a memorable advertising moment. The service can support aerial displays using Helicopter Gazelle and Cessna 172.",
      ar: "تستخدم خدمة الإعلانات الجوية من Swift Jet المروحيات والطائرات لنقل رسالة العلامة التجارية إلى السماء. الخدمة مناسبة للحملات التي تحتاج إلى ظهور قوي وجذب انتباه الجمهور وخلق لحظة إعلانية لا تُنسى. ويمكن تنفيذ العروض باستخدام Helicopter Gazelle وCessna 172.",
    },
    benefits: {
      en: [
        "High-visibility brand exposure",
        "Memorable campaign format",
        "Helicopter and aircraft display options",
        "Great for events and public campaigns",
      ],
      ar: [
        "ظهور قوي للعلامة التجارية",
        "شكل إعلاني لا يُنسى",
        "خيارات عرض بالمروحية والطائرة",
        "مناسب للفعاليات والحملات العامة",
      ],
    },
    audience: {
      en: "Brands, event organizers, tourism campaigns, marketers",
      ar: "العلامات التجارية، منظمو الفعاليات، الحملات السياحية، المسوقون",
    },
    duration: { en: "Campaign-based", ar: "حسب الحملة" },
    image: "/67bae2fe-43f7-4640-8848-2e038b92b118.png",
    cta: { en: "Start Your Campaign", ar: "ابدأ حملتك" },
    stats: [
      { label: { en: "Visibility", ar: "الظهور" }, value: "High" },
      { label: { en: "Aircraft", ar: "طائرات" }, value: "2+" },
      { label: { en: "Campaign Type", ar: "نوع الحملة" }, value: "Aerial" },
      { label: { en: "Impact", ar: "التأثير" }, value: "Strong" },
    ],
    gallery: [
      "/67bae2fe-43f7-4640-8848-2e038b92b118.png",
      "/ariel_advertisment/ariel_ad_3.png",
    ],
  },
  {
    key: "almaza-vip-terminal",
    title: { en: "Almaza VIP Terminal", ar: "صالة ألماظة VIP" },
    desc: {
      en: "Exclusive private jet departure and arrival experience with privacy, easy access, and discreet service.",
      ar: "تجربة مغادرة ووصول حصرية للطائرات الخاصة مع خصوصية وسهولة وصول وخدمة راقية.",
    },
    text: {
      en: "Swift Jet’s Almaza VIP Terminal elevates the private jet experience with exclusive departure and arrival services. The terminal offers stronger privacy compared to Cairo Airport Hall 4, easy road access, reduced traffic, and a discreet celebrity-friendly environment designed specifically for private jet flights.",
      ar: "ترتقي صالة ألماظة VIP من Swift Jet بتجربة الطيران الخاص من خلال خدمات مغادرة ووصول حصرية. توفر الصالة خصوصية أعلى مقارنة بصالة 4 في مطار القاهرة، مع سهولة وصول من الطريق الرئيسي وتقليل للزحام وبيئة راقية ومناسبة لكبار الشخصيات ومصممة خصيصًا لرحلات الطائرات الخاصة.",
    },
    benefits: {
      en: [
        "Private jet-focused terminal",
        "High privacy",
        "Easy road access",
        "Discreet VIP environment",
      ],
      ar: [
        "صالة مخصصة للطائرات الخاصة",
        "خصوصية عالية",
        "سهولة وصول من الطريق",
        "بيئة VIP هادئة وسرية",
      ],
    },
    audience: {
      en: "Private jet passengers, VIPs, celebrities, executives",
      ar: "ركاب الطائرات الخاصة، كبار الشخصيات، المشاهير، رجال الأعمال",
    },
    duration: {
      en: "Per departure or arrival",
      ar: "حسب رحلة المغادرة أو الوصول",
    },
    image: "/almaza-vip-terminal.jpeg",
    cta: { en: "Reserve VIP Terminal", ar: "احجز صالة VIP" },
    stats: [
      { label: { en: "Privacy", ar: "خصوصية" }, value: "100%" },
      { label: { en: "Access", ar: "سهولة الوصول" }, value: "Fast" },
      { label: { en: "Service", ar: "الخدمة" }, value: "VIP" },
      { label: { en: "Terminal", ar: "الصالة" }, value: "Almaza" },
    ],
    gallery: [
      "/almaza-vip-terminal.jpeg",
      "/almaza-vip-terminal.jpeg",
      "/almaza-vip-terminal.jpeg",
      "https://swiftjetaviation.com/wp-content/uploads/2024/03/WhatsApp-Image-2024-03-02-at-12.36.07-AM-1.jpeg",
    ],
  },
  // {
  //   key: 'paramotor-advertising',
  //   title: { en: 'Paramotor Advertising', ar: 'إعلانات الباراموتور' },
  //   desc: {
  //     en: 'Reach your audience with eye-catching paramotor displays.',
  //     ar: 'صل إلى جمهورك من خلال عروض الباراموتور الجذابة.'
  //   },
  //   text: {
  //     en: 'Engage your audience with the thrill of paramotor advertising. Our specialized paramotor flights draw attention and provide a unique advertising medium for beaches, festivals, and large outdoor gatherings.',
  //     ar: 'اجذب انتباه جمهورك بإثارة إعلانات الباراموتور. رحلاتنا المتخصصة بالباراموتور تلفت الانتباه وتوفر وسيلة إعلانية فريدة للشواطئ، والمهرجانات، والتجمعات الكبيرة في الهواء الطلق.'
  //   },
  //   benefits: {
  //     en: [
  //       'Engaging displays',
  //       'Perfect for outdoor events',
  //       'Unique brand exposure',
  //       'Flexible routing'
  //     ],
  //     ar: [
  //       'عروض جذابة',
  //       'مثالية للفعاليات الخارجية',
  //       'تعرض فريد للعلامة التجارية',
  //       'مرونة في المسارات'
  //     ]
  //   },
  //   audience: {
  //     en: 'Event Sponsors, Local Brands, Tourism Boards',
  //     ar: 'رعاة الفعاليات، العلامات التجارية المحلية، هيئات السياحة'
  //   },
  //   duration: { en: 'Event-based', ar: 'حسب الفعالية' },
  //   image: '/paramotor/paramotor-1.png',
  //   cta: { en: 'Book Paramotor Campaign', ar: 'احجز حملة باراموتور' },
  //   stats: [
  //     { label: { en: 'Engagement', ar: 'تفاعل' }, value: 'High' },
  //     { label: { en: 'Speed', ar: 'السرعة' }, value: 'Low' },
  //     { label: { en: 'Visibility', ar: 'رؤية' }, value: 'Direct' },
  //     { label: { en: 'Impact', ar: 'تأثير' }, value: '100%' }
  //   ],
  //   gallery: ['/paramotor/paramotor-1.png', '/paramotor/paramotor-2.png']
  // },
  {
    key: "flight-sightseeing-tour",
    title: { en: "Flight Sightseeing Tour", ar: "جولات الطيران السياحية" },
    desc: {
      en: "Aerial sightseeing over Cairo, the Pyramids, Luxor, Gouna, and Hurghada using Zlin aircraft or helicopters.",
      ar: "جولات مشاهدة جوية فوق القاهرة والأهرامات والأقصر والجونة والغردقة باستخدام طائرات Zlin أو المروحيات.",
    },
    text: {
      en: "Swift Jet’s Flight Sightseeing Tour lets guests experience Egypt from above aboard Zlin aircraft or helicopters. The tour covers Cairo and the Pyramids, with options for Pyramids landing, and extends to Luxor, Gouna, and Hurghada. It is suitable for birthdays, romantic dates, real estate tours, VIP clients, and investors who want to view locations and development progress from the air.",
      ar: "تتيح خدمة Flight Sightseeing Tour من Swift Jet مشاهدة مصر من السماء على متن طائرات Zlin أو المروحيات. تشمل الجولات القاهرة والأهرامات مع خيار الهبوط بالقرب من الأهرامات، وتمتد إلى الأقصر والجونة والغردقة. الخدمة مناسبة لأعياد الميلاد والمواعيد الرومانسية والجولات العقارية وكبار الشخصيات والمستثمرين الراغبين في رؤية المواقع والتطورات من الجو.",
    },
    benefits: {
      en: [
        "Cairo and Pyramids aerial route",
        "Zlin aircraft and helicopter options",
        "Pyramids landing add-on",
        "Great for birthdays, romantic dates, and real estate tours",
      ],
      ar: [
        "مسار جوي فوق القاهرة والأهرامات",
        "خيارات طائرات Zlin والمروحيات",
        "إضافة هبوط عند الأهرامات",
        "مناسبة لأعياد الميلاد والمواعيد الرومانسية والجولات العقارية",
      ],
    },
    audience: {
      en: "Tourists, VIPs, couples, investors, real estate clients",
      ar: "السياح، كبار الشخصيات، الأزواج، المستثمرون، عملاء العقارات",
    },
    duration: {
      en: "40 minutes for Cairo Sightseeing",
      ar: "40 دقيقة لجولة القاهرة",
    },
    image: "/4460dff2-298b-4bd6-aa84-58ad35651c2b.jfif",
    cta: { en: "Book Your Tour Now", ar: "احجز جولتك الآن" },
    stats: [
      { label: { en: "Trips", ar: "رحلة" }, value: "1000+" },
      { label: { en: "Happy Customers", ar: "عميل سعيد" }, value: "600+" },
      { label: { en: "Flying Hours", ar: "ساعة طيران" }, value: "800+" },
      { label: { en: "Destinations", ar: "وجهة" }, value: "4+" },
    ],
    gallery: [
      "/4460dff2-298b-4bd6-aa84-58ad35651c2b.jfif",
      "https://swiftjetaviation.com/wp-content/uploads/2022/01/WhatsApp-Image-2024-03-04-at-17.04.04-min.jpeg",
      // '/flightSeeing/Screenshot (1183).png',
      // '/flightSeeing/Screenshot (1184).png'
    ],
  },
  // {
  //   key: 'flightCrewTraining',
  //   title: { en: 'Flight Crew Training', ar: 'تدريب طاقم الطيران' },
  //   desc: {
  //     en: 'Structured training pathways for pilots, technicians, and cabin crew.',
  //     ar: 'مسارات تدريب منظمة للطيارين والفنيين وطاقم الضيافة الجوية.'
  //   },
  //   text: {
  //     en: 'Swift Jet Academy provides flight crew training for pilots, technicians, and cabin crew. The training structure includes pilot programs such as basic flight training, advanced flight training, and CPL preparation; technician programs such as aircraft systems, advanced maintenance, certification, and inspection; and cabin crew programs covering service, safety, emergency procedures, first aid, communication, and cultural sensitivity.',
  //     ar: 'تقدم Swift Jet Academy تدريبًا لطاقم الطيران يشمل الطيارين والفنيين وطاقم الضيافة. يتضمن البرنامج تدريب الطيارين على أساسيات الطيران والتدريب المتقدم والتحضير لرخصة CPL، وتدريب الفنيين على أنظمة الطائرات والصيانة المتقدمة والتفتيش والاعتماد، وتدريب طاقم الضيافة على الخدمة والسلامة والطوارئ والإسعافات الأولية والتواصل والثقافة المهنية.'
  //   },
  //   benefits: {
  //     en: [
  //       'Pilot training programs',
  //       'Technician maintenance training',
  //       'Cabin crew safety and service modules',
  //       'Simulation and practical training hours'
  //     ],
  //     ar: [
  //       'برامج تدريب للطيارين',
  //       'تدريب فنيي الصيانة',
  //       'وحدات سلامة وخدمة لطاقم الضيافة',
  //       'ساعات محاكاة وتدريب عملي'
  //     ]
  //   },
  //   audience: {
  //     en: 'Pilots, aircraft technicians, cabin crew trainees',
  //     ar: 'الطيارون، فنيو الطائرات، متدربو طاقم الضيافة'
  //   },
  //   duration: { en: '1 to 8 months depending on program', ar: 'من شهر إلى 8 أشهر حسب البرنامج' },
  //   image: '/gallery-3.png',
  //   cta: { en: 'Apply for Training', ar: 'قدّم على التدريب' },
  //   stats: [
  //     { label: { en: 'Pilot Tracks', ar: 'مسارات الطيارين' }, value: '3' },
  //     { label: { en: 'Technician Tracks', ar: 'مسارات الفنيين' }, value: '3' },
  //     { label: { en: 'Cabin Crew Tracks', ar: 'مسارات الضيافة' }, value: '3' },
  //     { label: { en: 'Max Program', ar: 'أطول برنامج' }, value: '8m' }
  //   ],
  //   gallery: ['/gallery-3.png', '/gallery-4.png', '/gallery-5.png', '/gallery-6.png']
  // },
  {
    key: "residency",
    title: { en: "Spain Residency", ar: "الإقامة في إسبانيا" },
    desc: {
      en: "Expert navigation through Spanish residency and legal pathways.",
      ar: "توجيه خبير عبر مسارات الإقامة والقوانين الإسبانية.",
    },
    text: {
      en: "FlyVia guides you through Spanish residency with complete legal support. Services include document preparation, family inclusion, legal compliance checks, fast processing, and step-by-step advisory.",
      ar: "FlyVia توجهك للحصول على الإقامة في إسبانيا بطريقة قانونية وسريعة. تشمل الخدمات تجهيز المستندات، متابعة قانونية، شمول العائلة، واستشارة خطوة بخطوة.",
    },
    benefits: {
      en: [
        "Access to Spain and EU travel",
        "Legal security and compliance",
        "Educational opportunities for children",
        "Healthcare coverage",
      ],
      ar: [
        "الوصول إلى إسبانيا والسفر داخل الاتحاد الأوروبي",
        "أمان قانوني والتزام",
        "فرص تعليمية للأطفال",
        "تغطية الرعاية الصحية",
      ],
    },
    audience: {
      en: "Families, investors, remote professionals",
      ar: "العائلات، المستثمرون، المحترفون عن بعد",
    },
    duration: { en: "20–40 business days", ar: "20–40 يوم عمل" },
    image: "/gallery-2.png",
    cta: { en: "Start Your Residency", ar: "ابدأ إجراءات الإقامة" },
    stats: [
      { label: { en: "Success Rate", ar: "نسبة النجاح" }, value: "100%" },
      { label: { en: "Families", ar: "عائلة" }, value: "150+" },
      { label: { en: "Processing", ar: "مدة الإجراءات" }, value: "30d" },
      { label: { en: "Lawyers", ar: "محامي" }, value: "10+" },
    ],
    gallery: [
      "/gallery-2.png",
      "/gallery-3.png",
      "/gallery-4.png",
      "/gallery-5.png",
    ],
  },
  {
    key: "nomad",
    title: { en: "Digital Nomad Visa", ar: "فيزا الرحالة الرقمي" },
    desc: {
      en: "Strategic support for remote professionals seeking life in Spain.",
      ar: "دعم استراتيجي للمهنيين عن بعد الساعين للحياة في إسبانيا.",
    },
    text: {
      en: "FlyVia assists freelancers and remote workers to obtain a Digital Nomad Visa in Spain. Services include eligibility assessment, visa application preparation, legal guidance, tax compliance support, and post-arrival integration.",
      ar: "FlyVia تساعد المستقلين والعمال عن بعد للحصول على فيزا الرحالة الرقمي في إسبانيا. تشمل الخدمات تقييم الأهلية، تجهيز المستندات، الإرشاد القانوني، دعم الضرائب، ودعم ما بعد الوصول.",
    },
    benefits: {
      en: [
        "Work legally in Spain",
        "Live in Europe without employer restrictions",
        "Access to social services",
        "Fast-track guidance",
      ],
      ar: [
        "العمل قانونيًا في إسبانيا",
        "العيش في أوروبا بدون قيود",
        "الوصول للخدمات الاجتماعية",
        "إرشاد سريع وشامل",
      ],
    },
    audience: {
      en: "Freelancers, remote workers",
      ar: "المستقلون، العمال عن بعد",
    },
    duration: { en: "30–45 days", ar: "30–45 يوم" },
    image: "/gallery-3.png",
    cta: { en: "Check Eligibility", ar: "تحقق من أهليتك" },
    stats: [
      { label: { en: "Digital Nomads", ar: "رحالة رقمي" }, value: "200+" },
      { label: { en: "Visa Approval", ar: "قبول الفيزا" }, value: "98%" },
      { label: { en: "Community", ar: "مجتمع" }, value: "500+" },
      { label: { en: "Cities", ar: "مدينة" }, value: "12+" },
    ],
    gallery: [
      "/gallery-3.png",
      "/gallery-4.png",
      "/gallery-5.png",
      "/gallery-6.png",
    ],
  },
  {
    key: "formation",
    title: { en: "Corporate Setup", ar: "تأسيس الشركات" },
    desc: {
      en: "Complete business establishment and administrative support in Europe.",
      ar: "دعم كامل لتأسيس الأعمال والإدارة في أوروبا.",
    },
    text: {
      en: "FlyVia helps launch companies in Spain or Europe from scratch. Services include company registration, accounting, tax setup, bank account opening, legal compliance, strategy guidance, and support for investors, startups, and SMEs.",
      ar: "FlyVia تساعد على تأسيس الشركات في إسبانيا أو أوروبا من البداية. تشمل الخدمات تسجيل الشركة، إعداد المحاسبة والضرائب، فتح حساب بنكي، الامتثال القانوني، الاستشارات الاستراتيجية، ودعم المستثمرين والمشاريع الناشئة.",
    },
    benefits: {
      en: [
        "Full A-to-Z company formation",
        "Compliance with Spanish and EU regulations",
        "Access to local business network",
        "Integration with residency applications",
      ],
      ar: [
        "تأسيس كامل A-to-Z",
        "امتثال للوائح الإسبانية والأوروبية",
        "الوصول للشبكات المحلية",
        "دمج مع طلبات الإقامة عند الحاجة",
      ],
    },
    audience: {
      en: "Entrepreneurs, investors",
      ar: "رواد الأعمال، المستثمرون",
    },
    duration: { en: "2–4 weeks", ar: "2–4 أسابيع" },
    image: "/gallery-4.png",
    cta: { en: "Start Your Company", ar: "ابدأ شركتك" },
    stats: [
      { label: { en: "Companies", ar: "شركة" }, value: "85+" },
      { label: { en: "Growth", ar: "نمو" }, value: "40%" },
      { label: { en: "Efficiency", ar: "كفاءة" }, value: "100%" },
      { label: { en: "Setup Time", ar: "وقت التأسيس" }, value: "15d" },
    ],
    gallery: [
      "/gallery-4.png",
      "/gallery-5.png",
      "/gallery-6.png",
      "/gallery-7.png",
    ],
  },
  {
    key: "investment",
    title: { en: "Investment Pathways", ar: "فرص الاستثمار" },
    desc: {
      en: "Opportunities linked to residency or business expansion.",
      ar: "فرص مرتبطة بالإقامة أو التوسع التجاري.",
    },
    text: {
      en: "FlyVia identifies investment opportunities in Spain and Europe, including real estate, commercial ventures, risk and compliance assessment, integration with residency planning, and market analysis.",
      ar: "FlyVia تحدد الفرص الاستثمارية في إسبانيا وأوروبا: الاستثمارات العقارية والتجارية، تقييم المخاطر، الامتثال القانوني، الدمج مع خطة الإقامة، وتحليل السوق.",
    },
    benefits: {
      en: [
        "Align investment with residency goals",
        "Mitigate financial and legal risks",
        "Expand business or portfolio in Europe",
      ],
      ar: [
        "مواءمة الاستثمار مع الإقامة",
        "تقليل المخاطر المالية والقانونية",
        "توسيع الأعمال أو المحافظ الاستثمارية في أوروبا",
      ],
    },
    audience: {
      en: "Investors, business owners",
      ar: "المستثمرون، أصحاب الأعمال",
    },
    duration: {
      en: "Ongoing until investment secured",
      ar: "مستمر حتى تأمين الاستثمار",
    },
    image: "/gallery-5.png",
    cta: { en: "Explore Investments", ar: "اكتشف الفرص" },
    stats: [
      { label: { en: "Investment", ar: "استثمارات" }, value: "€50M+" },
      { label: { en: "Projects", ar: "مشروع" }, value: "30+" },
      { label: { en: "ROI", ar: "عائد الاستثمار" }, value: "12%" },
      { label: { en: "Partners", ar: "شريك" }, value: "20+" },
    ],
    gallery: [
      "/gallery-5.png",
      "/gallery-6.png",
      "/gallery-7.png",
      "/gallery-8.png",
    ],
  },
  {
    key: "relocation",
    title: { en: "Elite Relocation", ar: "الانتقال المتميز" },
    desc: {
      en: "Dedicated management for a smooth transition into your new life.",
      ar: "إدارة مخصصة لانتقال سلس إلى حياتك الجديدة.",
    },
    text: {
      en: "Complete relocation services to ensure a smooth move to Spain or Europe, including accommodation booking, airport reception, healthcare setup, guidance on local regulations, and a personal relocation manager.",
      ar: "خدمات انتقال كاملة لضمان انتقال سلس إلى إسبانيا أو أوروبا، تشمل حجز السكن، استقبال المطار، تجهيز التأمين الصحي، الإرشاد بشأن القوانين المحلية، وموظف متابعة شخصي.",
    },
    benefits: {
      en: [
        "Stress-free relocation",
        "Full legal and administrative support",
        "Settling-in guidance",
      ],
      ar: ["انتقال بدون توتر", "دعم قانوني وإداري كامل", "إرشاد الاستقرار"],
    },
    audience: {
      en: "Families, High-net-worth individuals",
      ar: "العائلات، الأفراد أصحاب الدخل العالي",
    },
    duration: {
      en: "1–2 weeks for initial setup",
      ar: "1–2 أسابيع للإعداد الأولي",
    },
    image: "/gallery-6.png",
    cta: { en: "Plan Your Relocation", ar: "خطط انتقالك" },
    stats: [
      { label: { en: "Relocations", ar: "عملية انتقال" }, value: "300+" },
      { label: { en: "Satisfaction", ar: "رضا العملاء" }, value: "100%" },
      { label: { en: "Countries", ar: "دولة" }, value: "5" },
      { label: { en: "Avg Time", ar: "متوسط الوقت" }, value: "10d" },
    ],
    gallery: [
      "/gallery-6.png",
      "/gallery-7.png",
      "/gallery-8.png",
      "/gallery-9.png",
    ],
  },
  {
    key: "education",
    title: { en: "Education & Family", ar: "التعليم والعائلة" },
    desc: {
      en: "Planning for family settlement and school placements.",
      ar: "تخطيط لاستقرار العائلة والالتحاق بالمدارس.",
    },
    text: {
      en: "FlyVia helps families secure the best education for children and smooth integration into Europe, including school selection, enrollment, healthcare registration, and support for family settlement.",
      ar: "FlyVia تساعد العائلات في ضمان أفضل تعليم للأطفال وتسهيل اندماجهم في أوروبا، بما في ذلك اختيار المدارس، التسجيل، تجهيز الرعاية الصحية، ودعم استقرار العائلة.",
    },
    benefits: {
      en: [
        "Quality school enrollment",
        "Healthcare secured",
        "Smooth family integration",
      ],
      ar: [
        "تسجيل الأطفال في مدارس عالية الجودة",
        "تأمين الرعاية الصحية",
        "دمج سلس للعائلة",
      ],
    },
    audience: {
      en: "Families relocating to Europe",
      ar: "العائلات التي تنتقل إلى أوروبا",
    },
    duration: { en: "3–4 weeks", ar: "3–4 أسابيع" },
    image: "/gallery-7.png",
    cta: {
      en: "Secure Your Family's Future",
      ar: "أمن مستقبل عائلتك",
    },
    stats: [
      { label: { en: "Schools", ar: "مدرسة" }, value: "40+" },
      { label: { en: "Students", ar: "طالب" }, value: "120+" },
      { label: { en: "Admissions", ar: "قبولات" }, value: "100%" },
      { label: { en: "Tutors", ar: "معلم" }, value: "25+" },
    ],
    gallery: [
      "/gallery-7.png",
      "/gallery-8.png",
      "/gallery-9.png",
      "/gallery-10.png",
    ],
  },
  {
    key: "schengen",
    title: { en: "Schengen Support", ar: "دعم الشنجن" },
    desc: {
      en: "Streamlined visa review and preparation for European travel.",
      ar: "مراجعة وتجهيز تأشيرات السفر الأوروبية بسلاسة.",
    },
    text: {
      en: "FlyVia supports travelers preparing for Schengen visa applications with document review, application preparation, travel planning guidance, and risk reduction support to help build a stronger file.",
      ar: "FlyVia تدعم المسافرين في تجهيز طلبات فيزا الشنجن من خلال مراجعة المستندات، تجهيز الملف، إرشاد خطة السفر، وتقليل عوامل الرفض لبناء ملف أقوى.",
    },
    benefits: {
      en: [
        "Document preparation",
        "Application file review",
        "Travel planning support",
        "Reduced rejection risk",
      ],
      ar: [
        "تجهيز المستندات",
        "مراجعة ملف التقديم",
        "دعم خطة السفر",
        "تقليل احتمالات الرفض",
      ],
    },
    audience: {
      en: "Tourists, families, business travelers",
      ar: "السياح، العائلات، رجال الأعمال",
    },
    duration: { en: "Case-based", ar: "حسب الحالة" },
    image: "/gallery-3.png",
    cta: { en: "Prepare Your Visa File", ar: "جهز ملف الفيزا" },
    stats: [
      { label: { en: "Files", ar: "ملفات" }, value: "300+" },
      { label: { en: "Review", ar: "مراجعة" }, value: "Full" },
      { label: { en: "Support", ar: "دعم" }, value: "Step-by-step" },
      { label: { en: "Clarity", ar: "وضوح" }, value: "100%" },
    ],
    gallery: [
      "/gallery-3.png",
      "/gallery-4.png",
      "/gallery-5.png",
      "/gallery-6.png",
    ],
  },
  {
    key: "property",
    title: { en: "Luxury Real Estate", ar: "عقارات فاخرة" },
    desc: {
      en: "Exclusive access to premium properties in the Mediterranean.",
      ar: "الوصول الحصري للعقارات المميزة في البحر المتوسط.",
    },
    text: {
      en: "FlyVia provides access to handpicked luxury properties for investment or residence. Services include advisory support for safe acquisition and market guidance.",
      ar: "FlyVia توفر الوصول إلى عقارات مختارة للاستثمار أو السكن، مع تقديم استشارات لضمان عملية شراء آمنة وإرشادات السوق.",
    },
    benefits: {
      en: [
        "Exclusive property access",
        "Investment or residence opportunities",
        "Advisory for secure transactions",
      ],
      ar: [
        "وصول حصري للعقارات",
        "فرص استثمارية أو سكنية",
        "استشارات لضمان سلامة المعاملة",
      ],
    },
    audience: {
      en: "Investors, High-net-worth individuals",
      ar: "المستثمرون، أصحاب الدخل العالي",
    },
    duration: { en: "Varies depending on property", ar: "حسب العقار" },
    image: "/gallery-8.png",
    cta: { en: "View Properties", ar: "شاهد العقارات" },
    stats: [
      { label: { en: "Listings", ar: "عقار متاح" }, value: "500+" },
      { label: { en: "Sales", ar: "مبيعات" }, value: "€200M" },
      { label: { en: "Exclusives", ar: "عقارات حصرية" }, value: "45" },
      { label: { en: "Agents", ar: "وكيل" }, value: "15" },
    ],
    gallery: [
      "/gallery-8.png",
      "/gallery-9.png",
      "/gallery-10.png",
      "/gallery-1.png",
    ],
  },
  {
    key: "concierge",
    title: { en: "VIP Concierge", ar: "كونسيرج VIP" },
    desc: {
      en: "Lifestyle management and bespoke arrangements for the elite.",
      ar: "إدارة أسلوب الحياة وترتيبات مخصصة للنخبة.",
    },
    text: {
      en: "From private appointments to full lifestyle management, FlyVia concierge services include event and dining bookings, personalized itinerary planning, and dedicated support to meet exclusive client needs.",
      ar: "من المواعيد الخاصة إلى إدارة أسلوب الحياة الكامل، تشمل خدمات كونسيرج FlyVia حجز الفعاليات والمطاعم، تخطيط جدول شخصي، ودعم كامل لتلبية احتياجات العملاء الحصرية.",
    },
    benefits: {
      en: [
        "Tailored lifestyle management",
        "VIP support",
        "Full European integration",
      ],
      ar: ["إدارة أسلوب الحياة حسب الطلب", "دعم VIP", "دمج كامل في أوروبا"],
    },
    audience: {
      en: "VIPs, High-net-worth clients",
      ar: "كبار الشخصيات، العملاء ذوي الدخل العالي",
    },
    duration: { en: "Ongoing", ar: "مستمر حسب الحاجة" },
    image: "/gallery-10.png",
    cta: { en: "Request Concierge", ar: "اطلب كونسيرج" },
    stats: [
      { label: { en: "Requests", ar: "طلب" }, value: "1200+" },
      { label: { en: "Members", ar: "عضو" }, value: "100" },
      { label: { en: "Partners", ar: "شريك" }, value: "250+" },
      { label: { en: "Cities", ar: "مدينة" }, value: "20+" },
    ],
    gallery: [
      "/gallery-10.png",
      "/gallery-1.png",
      "/gallery-2.png",
      "/gallery-3.png",
    ],
  },
  {
    key: "egypt-category-a",
    type: "itinerary",
    title: {
      en: "Egypt as You Have Never Seen It Before — Category A",
      ar: "مصر كما لم ترها من قبل — الفئة A",
    },
    desc: {
      en: "5-star Egypt itinerary covering Cairo, the Grand Egyptian Museum, the Pyramids, Nile cruise highlights, Luxor and Aswan.",
      ar: "برنامج مصر 5 نجوم يشمل القاهرة والمتحف المصري الكبير والأهرامات ورحلة نيلية والأقصر وأسوان.",
    },
    text: {
      en: "A premium 5-star Egypt journey designed for guests who want a refined cultural experience with carefully selected hotels, guided sightseeing, Nile cruise highlights, and seamless transfers from arrival to departure.",
      ar: "برنامج مصر فاخر 5 نجوم مصمم للضيوف الباحثين عن تجربة ثقافية راقية تشمل فنادق مختارة بعناية، زيارات سياحية بإرشاد متخصص، أبرز محطات الرحلة النيلية، وانتقالات منظمة من الوصول حتى المغادرة.",
    },
    benefits: {
      en: [
        "5-star accommodation experience",
        "Cairo, Pyramids and Grand Egyptian Museum",
        "Nile cruise highlights between Aswan and Luxor",
        "Guided cultural sightseeing and airport assistance",
      ],
      ar: [
        "تجربة إقامة 5 نجوم",
        "القاهرة والأهرامات والمتحف المصري الكبير",
        "أبرز محطات الرحلة النيلية بين أسوان والأقصر",
        "زيارات ثقافية بإرشاد متخصص ومساعدة في المطارات",
      ],
    },
    audience: {
      en: "Luxury travelers, families, culture seekers",
      ar: "محبو السفر الفاخر، العائلات، المهتمون بالثقافة",
    },
    duration: {
      en: "7 Days / 6 Nights",
      ar: "7 أيام / 6 ليالٍ",
    },
    image: "/egypt-category-a-card.webp",
    cta: {
      en: "Request This Itinerary",
      ar: "اطلب هذا البرنامج",
    },
    stats: [
      { label: { en: "Category", ar: "الفئة" }, value: "A" },
      { label: { en: "Experience", ar: "التجربة" }, value: "5★" },
      { label: { en: "Days", ar: "أيام" }, value: "7" },
      { label: { en: "From", ar: "يبدأ من" }, value: "$2541" },
    ],
    gallery: ["/egypt-category-a-card.webp", "/egypt-category-b-card.webp"],
    itinerary: {
      en: [
        {
          day: "Day 01",
          title: "Arrival in Cairo & Cairo by Night",
          overnight: "Hotel in Cairo",
          highlights: [
            "Arrival at Cairo International Airport",
            "Airport assistance and transfer to the hotel",
            "Hotel check-in assistance",
            "Cairo by night around Al Moez Street and Khan El-Khalili Bazaar",
            "Dinner at Naguib Mahfouz or similar",
          ],
        },
        {
          day: "Day 02",
          title: "Grand Egyptian Museum, Pyramids & Sphinx",
          overnight: "Hotel in Cairo",
          highlights: [
            "Breakfast at hotel",
            "Grand Egyptian Museum visit",
            "Pyramids Plateau",
            "The Sphinx",
            "Lunch at 9 Pyramids Lounge or similar",
          ],
        },
        {
          day: "Day 03",
          title: "Cairo to Aswan & Nile Cruise",
          overnight: "On board Nile cruise",
          highlights: [
            "Breakfast and hotel check-out",
            "Transfer to Cairo Airport",
            "Domestic flight from Cairo to Aswan",
            "Nile cruise embarkation",
            "Aswan sightseeing program",
          ],
        },
        {
          day: "Day 04",
          title: "Kom Ombo & Edfu",
          overnight: "On board Nile cruise",
          highlights: [
            "Sailing to Kom Ombo",
            "Visit Kom Ombo Temple",
            "Visit Edfu Temple",
            "Continue sailing toward Luxor",
          ],
        },
        {
          day: "Day 05",
          title: "Luxor West Bank",
          overnight: "On board Nile cruise",
          highlights: [
            "Valley of the Kings",
            "Valley of the Queens",
            "Colossus of Memnon",
            "Evening on board",
          ],
        },
        {
          day: "Day 06",
          title: "Karnak, Luxor Temple & Return to Cairo",
          overnight: "Hotel in Cairo",
          highlights: [
            "Breakfast on board and disembarkation",
            "Karnak Temple",
            "Luxor Temple",
            "Transfer to Luxor Airport",
            "Domestic flight to Cairo and hotel check-in",
          ],
        },
        {
          day: "Day 07",
          title: "NMEC, Egyptian Museum & Departure",
          overnight: "End of services",
          highlights: [
            "Breakfast and check-out",
            "National Museum of Egyptian Civilization",
            "Egyptian Museum",
            "Lunch at Le Pacha or similar",
            "Transfer to Cairo Airport for international departure",
          ],
        },
      ],
      ar: [
        {
          day: "اليوم 01",
          title: "الوصول إلى القاهرة وجولة القاهرة ليلًا",
          overnight: "فندق في القاهرة",
          highlights: [
            "الوصول إلى مطار القاهرة الدولي",
            "مساعدة في إجراءات المطار والانتقال إلى الفندق",
            "مساعدة في تسجيل الدخول بالفندق",
            "جولة القاهرة ليلًا في شارع المعز وخان الخليلي",
            "عشاء في نجيب محفوظ أو ما شابه",
          ],
        },
        {
          day: "اليوم 02",
          title: "المتحف المصري الكبير والأهرامات وأبو الهول",
          overnight: "فندق في القاهرة",
          highlights: [
            "إفطار في الفندق",
            "زيارة المتحف المصري الكبير",
            "زيارة منطقة الأهرامات",
            "زيارة أبو الهول",
            "غداء في 9 Pyramids Lounge أو ما شابه",
          ],
        },
        {
          day: "اليوم 03",
          title: "من القاهرة إلى أسوان وبدء الرحلة النيلية",
          overnight: "على متن الرحلة النيلية",
          highlights: [
            "إفطار ومغادرة الفندق",
            "الانتقال إلى مطار القاهرة",
            "طيران داخلي من القاهرة إلى أسوان",
            "تسجيل الدخول على الرحلة النيلية",
            "برنامج زيارات أسوان",
          ],
        },
        {
          day: "اليوم 04",
          title: "كوم أمبو وإدفو",
          overnight: "على متن الرحلة النيلية",
          highlights: [
            "الإبحار إلى كوم أمبو",
            "زيارة معبد كوم أمبو",
            "زيارة معبد إدفو",
            "استكمال الإبحار باتجاه الأقصر",
          ],
        },
        {
          day: "اليوم 05",
          title: "البر الغربي في الأقصر",
          overnight: "على متن الرحلة النيلية",
          highlights: [
            "وادي الملوك",
            "وادي الملكات",
            "تمثالا ممنون",
            "مساء على متن الرحلة النيلية",
          ],
        },
        {
          day: "اليوم 06",
          title: "الكرنك ومعبد الأقصر والعودة إلى القاهرة",
          overnight: "فندق في القاهرة",
          highlights: [
            "إفطار على متن الرحلة ومغادرة المركب",
            "زيارة معبد الكرنك",
            "زيارة معبد الأقصر",
            "الانتقال إلى مطار الأقصر",
            "طيران داخلي إلى القاهرة وتسجيل الدخول بالفندق",
          ],
        },
        {
          day: "اليوم 07",
          title: "المتحف القومي للحضارة والمتحف المصري والمغادرة",
          overnight: "نهاية الخدمات",
          highlights: [
            "إفطار ومغادرة الفندق",
            "زيارة المتحف القومي للحضارة المصرية",
            "زيارة المتحف المصري",
            "غداء في Le Pacha أو ما شابه",
            "الانتقال إلى مطار القاهرة للمغادرة الدولية",
          ],
        },
      ],
    },
    rates: [
      {
        period: "15 June - 31 August 2026",
        pax2: 3013,
        pax3To4: 2760,
        pax5To7: 2610,
        pax8To10: 2541,
      },
      {
        period: "1 - 30 September 2026",
        pax2: 3271,
        pax3To4: 3013,
        pax5To7: 2863,
        pax8To10: 2800,
      },
      {
        period: "1 October - 20 December 2026",
        pax2: 3559,
        pax3To4: 3306,
        pax5To7: 3156,
        pax8To10: 3087,
      },
      {
        period: "20 - 31 December 2026",
        pax2: 4180,
        pax3To4: 3927,
        pax5To7: 3777,
        pax8To10: 3714,
      },
    ],
    domesticFlight: {
      route: "Cairo - Aswan / Luxor - Cairo",
      perAdult: 437,
      note: "Subject to change",
    },
    inclusions: {
      en: [
        "02 nights at Four Seasons First Residence or similar on Bed & Breakfast basis",
        "03 nights at M/s Jaz Regent or similar on Full Board basis",
        "01 night at Waldorf Astoria Heliopolis or similar on Bed & Breakfast basis",
        "Airport assistance and entry visa",
        "All transfers as mentioned in the itinerary",
        "English speaking representative escort during all transfers",
        "English speaking guide throughout the tour",
        "Grand Egyptian Museum and Pyramids visit with lunch",
        "National Museum of Civilization and Egyptian Museum visit with lunch",
        "Cairo by night with dinner",
        "Luxor and Karnak temples",
        "Valley of Kings, Valley of Queens and Colossus of Memnon",
        "Edfu Temple and Kom Ombo Temple",
        "High Dam, Unfinished Obelisk and Philae Temple",
      ],
      ar: [
        "ليلتان في Four Seasons First Residence أو ما شابه على أساس الإفطار",
        "3 ليالٍ على متن M/s Jaz Regent أو ما شابه على أساس الإقامة الكاملة",
        "ليلة في Waldorf Astoria Heliopolis أو ما شابه على أساس الإفطار",
        "مساعدة في المطار وتأشيرة دخول",
        "كل الانتقالات المذكورة في البرنامج",
        "ممثل ناطق بالإنجليزية خلال الانتقالات",
        "مرشد ناطق بالإنجليزية طوال الجولة",
        "زيارة المتحف المصري الكبير والأهرامات مع الغداء",
        "زيارة المتحف القومي للحضارة والمتحف المصري مع الغداء",
        "جولة القاهرة ليلًا مع العشاء",
        "معابد الأقصر والكرنك",
        "وادي الملوك ووادي الملكات وتمثالا ممنون",
        "معبد إدفو ومعبد كوم أمبو",
        "السد العالي والمسلة الناقصة ومعبد فيلة",
      ],
    },
    exclusions: {
      en: [
        "Extras",
        "Domestic or international flights",
        "Personal expenses",
        "Tipping for drivers, guide and representatives",
        "Abu Simbel excursion by plane",
        "Beverages",
        "Any other service not mentioned in the itinerary",
      ],
      ar: [
        "أي مصاريف إضافية",
        "الطيران الداخلي أو الدولي",
        "المصاريف الشخصية",
        "الإكراميات للسائقين والمرشد والممثلين",
        "رحلة أبو سمبل بالطائرة",
        "المشروبات",
        "أي خدمة أخرى غير مذكورة في البرنامج",
      ],
    },
    notes: {
      en: [
        "No space is blocked until receiving confirmation",
        "Rates are net and non-commissionable",
        "Domestic flight rate is subject to change",
      ],
      ar: [
        "لا يتم حجز أي مساحة إلا بعد استلام التأكيد",
        "الأسعار صافية وغير قابلة للعمولة",
        "سعر الطيران الداخلي قابل للتغيير",
      ],
    },
  },
  {
    key: "egypt-category-b",
    type: "itinerary",
    title: {
      en: "Egypt as You Have Never Seen It Before — Category B",
      ar: "مصر كما لم ترها من قبل — الفئة B",
    },
    desc: {
      en: "4-star Egypt itinerary covering Cairo, the Grand Egyptian Museum, the Pyramids, Nile cruise highlights, Luxor and Aswan.",
      ar: "برنامج مصر 4 نجوم يشمل القاهرة والمتحف المصري الكبير والأهرامات ورحلة نيلية والأقصر وأسوان.",
    },
    text: {
      en: "A curated 4-star Egypt journey designed for guests who want a comfortable cultural experience with key Cairo highlights, Nile cruise discoveries, Luxor and Aswan sightseeing, and organized travel support throughout the program.",
      ar: "برنامج مصر 4 نجوم مصمم للضيوف الباحثين عن تجربة ثقافية مريحة تشمل أبرز معالم القاهرة، الرحلة النيلية، زيارات الأقصر وأسوان، ودعم منظم طوال البرنامج.",
    },
    benefits: {
      en: [
        "4-star comfortable travel experience",
        "Cairo, Pyramids and Grand Egyptian Museum",
        "Nile cruise highlights between Aswan and Luxor",
        "Organized transfers and guided sightseeing",
      ],
      ar: [
        "تجربة سفر مريحة 4 نجوم",
        "القاهرة والأهرامات والمتحف المصري الكبير",
        "أبرز محطات الرحلة النيلية بين أسوان والأقصر",
        "انتقالات منظمة وزيارات بإرشاد متخصص",
      ],
    },
    audience: {
      en: "Families, groups, culture travelers",
      ar: "العائلات، المجموعات، محبو الرحلات الثقافية",
    },
    duration: {
      en: "7 Days / 6 Nights",
      ar: "7 أيام / 6 ليالٍ",
    },
    image: "/egypt-category-b-card.webp",
    cta: {
      en: "Request This Itinerary",
      ar: "اطلب هذا البرنامج",
    },
    stats: [
      { label: { en: "Category", ar: "الفئة" }, value: "B" },
      { label: { en: "Experience", ar: "التجربة" }, value: "4★" },
      { label: { en: "Days", ar: "أيام" }, value: "7" },
      { label: { en: "From", ar: "يبدأ من" }, value: "$2012" },
    ],
    gallery: ["/egypt-category-b-card.webp", "/egypt-category-a-card.webp"],
    itinerary: {
      en: [
        {
          day: "Day 01",
          title: "Arrival in Cairo & Cairo by Night",
          overnight: "Hotel in Cairo",
          highlights: [
            "Arrival at Cairo International Airport",
            "Airport assistance and transfer to the hotel",
            "Hotel check-in assistance",
            "Cairo by night around Al Moez Street and Khan El-Khalili Bazaar",
            "Dinner at local restaurant",
          ],
        },
        {
          day: "Day 02",
          title: "Grand Egyptian Museum, Pyramids & Sphinx",
          overnight: "Hotel in Cairo",
          highlights: [
            "Breakfast at hotel",
            "Grand Egyptian Museum visit",
            "Pyramids Plateau",
            "The Sphinx",
            "Lunch at local restaurant",
          ],
        },
        {
          day: "Day 03",
          title: "Cairo to Aswan & Nile Cruise",
          overnight: "On board Nile cruise",
          highlights: [
            "Breakfast and hotel check-out",
            "Transfer to Cairo Airport",
            "Domestic flight from Cairo to Aswan",
            "Nile cruise embarkation",
            "Aswan sightseeing program",
          ],
        },
        {
          day: "Day 04",
          title: "Kom Ombo & Edfu",
          overnight: "On board Nile cruise",
          highlights: [
            "Sailing to Kom Ombo",
            "Visit Kom Ombo Temple",
            "Visit Edfu Temple",
            "Continue sailing toward Luxor",
          ],
        },
        {
          day: "Day 05",
          title: "Luxor West Bank",
          overnight: "On board Nile cruise",
          highlights: [
            "Valley of the Kings",
            "Valley of the Queens",
            "Colossus of Memnon",
            "Evening on board",
          ],
        },
        {
          day: "Day 06",
          title: "Karnak, Luxor Temple & Return to Cairo",
          overnight: "Hotel in Cairo",
          highlights: [
            "Breakfast on board and disembarkation",
            "Karnak Temple",
            "Luxor Temple",
            "Transfer to Luxor Airport",
            "Domestic flight to Cairo and hotel check-in",
          ],
        },
        {
          day: "Day 07",
          title: "NMEC, Egyptian Museum & Departure",
          overnight: "End of services",
          highlights: [
            "Breakfast and check-out",
            "National Museum of Egyptian Civilization",
            "Egyptian Museum",
            "Lunch at local restaurant",
            "Transfer to Cairo Airport for international departure",
          ],
        },
      ],
      ar: [
        {
          day: "اليوم 01",
          title: "الوصول إلى القاهرة وجولة القاهرة ليلًا",
          overnight: "فندق في القاهرة",
          highlights: [
            "الوصول إلى مطار القاهرة الدولي",
            "مساعدة في إجراءات المطار والانتقال إلى الفندق",
            "مساعدة في تسجيل الدخول بالفندق",
            "جولة القاهرة ليلًا في شارع المعز وخان الخليلي",
            "عشاء في مطعم محلي",
          ],
        },
        {
          day: "اليوم 02",
          title: "المتحف المصري الكبير والأهرامات وأبو الهول",
          overnight: "فندق في القاهرة",
          highlights: [
            "إفطار في الفندق",
            "زيارة المتحف المصري الكبير",
            "زيارة منطقة الأهرامات",
            "زيارة أبو الهول",
            "غداء في مطعم محلي",
          ],
        },
        {
          day: "اليوم 03",
          title: "من القاهرة إلى أسوان وبدء الرحلة النيلية",
          overnight: "على متن الرحلة النيلية",
          highlights: [
            "إفطار ومغادرة الفندق",
            "الانتقال إلى مطار القاهرة",
            "طيران داخلي من القاهرة إلى أسوان",
            "تسجيل الدخول على الرحلة النيلية",
            "برنامج زيارات أسوان",
          ],
        },
        {
          day: "اليوم 04",
          title: "كوم أمبو وإدفو",
          overnight: "على متن الرحلة النيلية",
          highlights: [
            "الإبحار إلى كوم أمبو",
            "زيارة معبد كوم أمبو",
            "زيارة معبد إدفو",
            "استكمال الإبحار باتجاه الأقصر",
          ],
        },
        {
          day: "اليوم 05",
          title: "البر الغربي في الأقصر",
          overnight: "على متن الرحلة النيلية",
          highlights: [
            "وادي الملوك",
            "وادي الملكات",
            "تمثالا ممنون",
            "مساء على متن الرحلة النيلية",
          ],
        },
        {
          day: "اليوم 06",
          title: "الكرنك ومعبد الأقصر والعودة إلى القاهرة",
          overnight: "فندق في القاهرة",
          highlights: [
            "إفطار على متن الرحلة ومغادرة المركب",
            "زيارة معبد الكرنك",
            "زيارة معبد الأقصر",
            "الانتقال إلى مطار الأقصر",
            "طيران داخلي إلى القاهرة وتسجيل الدخول بالفندق",
          ],
        },
        {
          day: "اليوم 07",
          title: "المتحف القومي للحضارة والمتحف المصري والمغادرة",
          overnight: "نهاية الخدمات",
          highlights: [
            "إفطار ومغادرة الفندق",
            "زيارة المتحف القومي للحضارة المصرية",
            "زيارة المتحف المصري",
            "غداء في مطعم محلي",
            "الانتقال إلى مطار القاهرة للمغادرة الدولية",
          ],
        },
      ],
    },
    rates: [
      {
        period: "15 June - 31 August 2026",
        pax2: 2487,
        pax3To4: 2225,
        pax5To7: 2075,
        pax8To10: 2012,
      },
      {
        period: "1 - 30 September 2026",
        pax2: 2507,
        pax3To4: 2254,
        pax5To7: 2104,
        pax8To10: 3035,
        reviewRequired: true,
      },
      {
        period: "1 October - 20 December 2026",
        pax2: 3306,
        pax3To4: 3053,
        pax5To7: 2903,
        pax8To10: 2835,
      },
      {
        period: "20 - 31 December 2026",
        pax2: 3841,
        pax3To4: 3588,
        pax5To7: 3438,
        pax8To10: 3369,
      },
    ],
    domesticFlight: {
      route: "Cairo - Aswan / Luxor - Cairo",
      perAdult: 437,
      note: "Subject to change",
    },
    inclusions: {
      en: [
        "02 nights at Steigenberger El Tahrir or similar on Bed & Breakfast basis",
        "03 nights at M/s Le Fayan or similar on Full Board basis",
        "01 night at Hilton Heliopolis or similar on Bed & Breakfast basis",
        "Airport assistance and entry visa",
        "All transfers as mentioned in the itinerary",
        "English speaking representative escort during all transfers",
        "English speaking guide throughout the tour",
        "Grand Egyptian Museum and Pyramids visit with lunch",
        "National Museum of Civilization and Egyptian Museum visit with lunch",
        "Cairo by night with dinner",
        "Luxor and Karnak temples",
        "Valley of Kings, Valley of Queens and Colossus of Memnon",
        "Edfu Temple and Kom Ombo Temple",
        "High Dam, Unfinished Obelisk and Philae Temple",
      ],
      ar: [
        "ليلتان في Steigenberger El Tahrir أو ما شابه على أساس الإفطار",
        "3 ليالٍ على متن M/s Le Fayan أو ما شابه على أساس الإقامة الكاملة",
        "ليلة في Hilton Heliopolis أو ما شابه على أساس الإفطار",
        "مساعدة في المطار وتأشيرة دخول",
        "كل الانتقالات المذكورة في البرنامج",
        "ممثل ناطق بالإنجليزية خلال الانتقالات",
        "مرشد ناطق بالإنجليزية طوال الجولة",
        "زيارة المتحف المصري الكبير والأهرامات مع الغداء",
        "زيارة المتحف القومي للحضارة والمتحف المصري مع الغداء",
        "جولة القاهرة ليلًا مع العشاء",
        "معابد الأقصر والكرنك",
        "وادي الملوك ووادي الملكات وتمثالا ممنون",
        "معبد إدفو ومعبد كوم أمبو",
        "السد العالي والمسلة الناقصة ومعبد فيلة",
      ],
    },
    exclusions: {
      en: [
        "Extras",
        "Domestic or international flights",
        "Personal expenses",
        "Tipping for drivers, guide and representatives",
        "Abu Simbel excursion by plane",
        "Beverages",
        "Any other service not mentioned in the itinerary",
      ],
      ar: [
        "أي مصاريف إضافية",
        "الطيران الداخلي أو الدولي",
        "المصاريف الشخصية",
        "الإكراميات للسائقين والمرشد والممثلين",
        "رحلة أبو سمبل بالطائرة",
        "المشروبات",
        "أي خدمة أخرى غير مذكورة في البرنامج",
      ],
    },
    notes: {
      en: [
        "No space is blocked until receiving confirmation",
        "Rates are net and non-commissionable",
        "Domestic flight rate is subject to change",
        "The September 8-10 pax value should be confirmed before publishing",
      ],
      ar: [
        "لا يتم حجز أي مساحة إلا بعد استلام التأكيد",
        "الأسعار صافية وغير قابلة للعمولة",
        "سعر الطيران الداخلي قابل للتغيير",
        "سعر سبتمبر لعدد 8-10 أفراد يحتاج مراجعة قبل النشر",
      ],
    },
  },
];

export default function ServiceDetails() {
  const { id } = useParams();
  const { currentLang, isInitialized } = useLanguage();
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const langKey = currentLang === "ar" ? "ar" : "en";
  const isAR = langKey === "ar";
  const normalizedId = serviceAliases[id] || id;

  const service = useMemo(() => {
    return (
      flyviaServicesFullBilingual.find((s) => s.key === normalizedId) ||
      flyviaServicesFullBilingual[0]
    );
  }, [normalizedId]);

  const isAviation = aviationKeys.includes(service?.key);
  const isItinerary = service?.type === "itinerary";
  const isDarkExperience = isAviation || isItinerary;

  const isPremium = useMemo(() => {
    const titleEn = service?.title?.en?.toLowerCase() || "";
    const key = service?.key?.toLowerCase() || "";

    return (
      titleEn.includes("vip") ||
      titleEn.includes("luxury") ||
      titleEn.includes("private") ||
      key.includes("vip") ||
      isAviation ||
      isItinerary
    );
  }, [service, isAviation, isItinerary]);

  const theme = {
    bg: isPremium ? "#07111f" : "#fff",
    text: isPremium ? "#fff" : "#07111f",
    accent: isPremium ? "#d4af37" : "#ae0001",
    cardBg: isPremium ? "rgba(255,255,255,0.03)" : "#f8fafc",
    border: isPremium ? "rgba(255,255,255,0.1)" : "#f1f5f9",
  };

  const formatMoney = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(value);
  };
  const galleryScope = service?.key
    ? service.key.replace(/[^a-zA-Z0-9_-]/g, "-")
    : "gallery";

  useEffect(() => {
    if (!isInitialized) return;

    const ctx = gsap.context(() => {
      gsap.from(".reveal-up", {
        y: 40,
        opacity: 0,
        stagger: 0.1,
        duration: 1,
        ease: "power3.out",
      });
    }, containerRef);

    window.scrollTo(0, 0);

    return () => ctx.revert();
  }, [isInitialized, id]);

  if (!isInitialized || !service) return null;

  return (
    <div
      className="service-details-bilingual"
      ref={containerRef}
      dir={isAR ? "rtl" : "ltr"}
    >
      <SEO
        title={service.title[langKey]}
        description={service.desc[langKey]}
        keywords={`${service.title.en}, ${service.key}, FlyVia ${service.title.en}, Swift Jet ${service.title.en}`}
      />

      <style>{`
        .service-details-bilingual {
          background: ${theme.bg};
          color: ${theme.text};
          min-height: 100vh;
          font-family: var(--font-primary);
          overflow-x: hidden;
        }

        .page-banner {
          position: relative;
          height: 55vh;
          min-height: 500px;
          background: linear-gradient(rgba(7, 17, 31, 0.75), rgba(7, 17, 31, 0.85)), url(${service.image});
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #fff;
          clip-path: polygon(0 0, 100% 0, 100% 92%, 50% 100%, 0 92%);
          margin-bottom: 100px;
        }

        .banner-content h1 {
          font-family: var(--font-heading);
          font-size: clamp(38px, 7vw, 84px);
          font-weight: 800;
          margin-bottom: 25px;
          text-transform: uppercase;
          letter-spacing: -1px;
          line-height: 1;
        }

        .breadcrumbs {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          font-family: var(--font-secondary);
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.15em;
          font-weight: 700;
        }

        .breadcrumbs a {
          color: #fff;
          text-decoration: none;
          opacity: 0.6;
          transition: 0.3s;
        }

        .breadcrumbs a:hover {
          opacity: 1;
        }

        .breadcrumbs span {
          color: ${theme.accent};
        }

        .refined-about-section {
          padding: 10px 0;
          background: ${isDarkExperience ? "#07111f" : "#fcfcfd"};
          color: ${isDarkExperience ? "#fff" : "#07111f"};
          position: relative;
        }

        .about-visual-container {
          position: relative;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 40px 80px rgba(0,0,0,0.25);
        }

        .about-visual-container img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: 1s var(--ease);
        }

        .about-decorative-glow {
          position: absolute;
          width: 300px;
          height: 300px;
          background: ${theme.accent};
          filter: blur(150px);
          opacity: 0.15;
          z-index: -1;
          ${isAR ? "right: -100px;" : "left: -100px;"}
          top: -50px;
        }

        .about-content-refined h2 {
          font-family: var(--font-heading);
          font-size: clamp(32px, 4vw, 56px);
          margin-bottom: 30px;
          font-weight: 800;
          line-height: 1.1;
        }

        .about-content-refined h2 span {
          display: inline-block;
          background: ${theme.accent};
          color: ${isDarkExperience && theme.accent === "#d4af37" ? "#000" : "#fff"} !important;
          padding: 0 15px;
          margin-left: 5px;
        }

        .about-content-refined p {
          font-size: 18px;
          line-height: 1.8;
          opacity: 0.8;
          margin-bottom: 40px;
        }

        .stats-section-final {
          padding: 120px 0;
          background: linear-gradient(rgba(7, 17, 31, 0.92), rgba(7, 17, 31, 0.92)), url(${service.image});
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          color: #fff;
          text-align: center;
        }

        .stat-item-refined {
          padding: 30px;
          border-right: 1px solid rgba(255,255,255,0.1);
        }

        .stat-item-refined:last-child {
          border: none;
        }

        .stat-value-refined {
          font-family: var(--font-heading);
          font-size: clamp(40px, 5vw, 64px);
          font-weight: 800;
          display: block;
          margin-bottom: 10px;
        }

        .stat-plus {
          color: ${theme.accent};
          margin-left: 5px;
        }

        .stat-label-refined {
          font-family: var(--font-secondary);
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.2em;
          opacity: 0.6;
        }

      .gallery-section-final {
  padding: 110px 0 120px;
  background: ${theme.bg};
  position: relative;
  overflow: hidden;
}

.gallery-header {
  text-align: center;
  margin-bottom: 48px;
  padding: 0 18px;
}

.gallery-eyebrow {
  color: ${theme.accent};
  font-family: var(--font-secondary);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.35em;
  display: block;
  margin-bottom: 16px;
  font-weight: 800;
}

.gallery-title {
  font-family: var(--font-heading);
  font-size: clamp(32px, 5vw, 58px);
  font-weight: 800;
  color: ${theme.text};
  line-height: 1.15;
  max-width: 1100px;
  margin: 0 auto;
}

.gallery-swiper-shell {
  position: relative;
  // max-width: 1180px;
  margin: 0 auto;
  padding: 0 76px 74px;
}

.gallery-swiper {
  overflow: hidden;
  padding: 18px 0 46px;
  border-radius: 34px;
}

.gallery-swiper .swiper-wrapper {
  align-items: center;
}

.gallery-swiper .swiper-slide {
  height: auto;
  opacity: 0.32;
  transform: scale(0.9);
  transition:
    transform 0.55s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.55s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.gallery-swiper .swiper-slide-prev,
.gallery-swiper .swiper-slide-next {
  opacity: 0.65;
  transform: scale(0.94);
}

.gallery-swiper .swiper-slide-active {
  opacity: 1;
  transform: scale(1);
}

.gallery-slide-card {
  position: relative;
  overflow: hidden;
  border-radius: 28px;
  background: ${isDarkExperience ? "rgba(255,255,255,0.04)" : "#fff"};
  border: 1px solid ${theme.border};
  box-shadow: 0 28px 70px rgba(0,0,0,0.32);
}

.gallery-slide-card::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: inherit;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.08);
}

.gallery-slide-img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;
  border-radius: 28px;
  filter: none;
  transform: none;
  transition: transform 0.7s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.gallery-slide-card:hover .gallery-slide-img {
  transform: scale(1.04);
}

.gallery-nav-btn {
  position: absolute;
  top: calc(50% - 18px);
  width: 54px;
  height: 54px;
  border-radius: 999px;
  border: 1px solid ${isDarkExperience ? "rgba(212,175,55,0.45)" : "rgba(174,0,1,0.35)"};
  background: ${isDarkExperience ? "rgba(7,17,31,0.88)" : "rgba(255,255,255,0.95)"};
  color: ${theme.accent};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 8;
  cursor: pointer;
  box-shadow: 0 18px 38px rgba(0,0,0,0.28);
  backdrop-filter: blur(10px);
  transition:
    transform 0.3s ease,
    background 0.3s ease,
    border-color 0.3s ease,
    color 0.3s ease,
    opacity 0.3s ease;
}

.gallery-nav-btn:hover {
  transform: translateY(-2px);
  background: ${theme.accent};
  color: ${isDarkExperience && theme.accent === "#d4af37" ? "#07111f" : "#fff"};
  border-color: ${theme.accent};
}

.gallery-nav-btn.swiper-button-disabled {
  opacity: 0.28;
  cursor: not-allowed;
  pointer-events: none;
}

.gallery-nav-prev {
  left: 10px;
}

.gallery-nav-next {
  right: 10px;
}

.gallery-custom-pagination {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  z-index: 7;
}

.gallery-custom-pagination .swiper-pagination-bullet {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  margin: 0 !important;
  opacity: 1;
  background: ${isDarkExperience ? "rgba(255,255,255,0.28)" : "rgba(7,17,31,0.22)"};
  transition:
    width 0.3s ease,
    background 0.3s ease,
    transform 0.3s ease;
}

.gallery-custom-pagination .swiper-pagination-bullet-active {
  width: 34px;
  background: ${theme.accent};
  transform: scale(1.02);
}

@media (max-width: 991px) {
  .gallery-swiper-shell {
    padding: 0 54px 68px;
  }

  .gallery-nav-btn {
    width: 46px;
    height: 46px;
  }

  .gallery-nav-prev {
    left: 4px;
  }

  .gallery-nav-next {
    right: 4px;
  }
}

@media (max-width: 575px) {
  .gallery-section-final {
    padding: 75px 0 90px;
  }

  .gallery-header {
    margin-bottom: 30px;
  }

  .gallery-title {
    font-size: 31px;
  }

  .gallery-swiper-shell {
    padding: 0 18px 62px;
  }

  .gallery-swiper {
    border-radius: 24px;
    padding-bottom: 38px;
  }

  .gallery-swiper .swiper-slide,
  .gallery-swiper .swiper-slide-prev,
  .gallery-swiper .swiper-slide-next,
  .gallery-swiper .swiper-slide-active {
    opacity: 1;
    transform: none;
  }

  .gallery-slide-card,
  .gallery-slide-img {
    border-radius: 22px;
  }

  .gallery-nav-btn {
    top: auto;
    bottom: 0;
    width: 44px;
    height: 44px;
  }

  .gallery-nav-prev {
    left: calc(50% - 88px);
  }

  .gallery-nav-next {
    right: calc(50% - 88px);
  }

  .gallery-custom-pagination {
    bottom: 12px;
  }
}
        .gold-accent-text {
          color: #d4af37 !important;
          font-weight: 800;
          text-shadow: 0 0 10px rgba(212, 175, 55, 0.3);
          display: inline;
        }

        .benefit-card-final {
          background: ${theme.cardBg};
          border: 1px solid ${theme.border};
          padding: 35px;
          border-radius: 20px;
          height: 100%;
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }

        .benefit-card-final:hover {
          transform: translateY(-10px);
          border-color: ${theme.accent};
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
        }

        .sidebar-card-final {
          background: ${isDarkExperience ? "rgba(255,255,255,0.05)" : "#07111f"};
          color: #fff;
          padding: 45px;
          border-radius: 24px;
          position: sticky;
          top: 120px;
          box-shadow: 0 30px 60px rgba(0,0,0,0.15);
        }

        .info-pill-final {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 15px 0;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }

        .info-pill-final:last-child {
          border: none;
        }

        .pill-icon {
          font-size: 20px;
          color: ${theme.accent};
        }

        .pill-label {
          font-size: 12px;
          text-transform: uppercase;
          opacity: 0.5;
          display: block;
          margin-bottom: 2px;
        }

        .pill-value {
          font-size: 15px;
          font-weight: 700;
        }

        .cta-btn-refined {
          background: ${theme.accent};
          color: ${isDarkExperience && theme.accent === "#d4af37" ? "#000" : "#fff"};
          border: none;
          padding: 18px 40px;
          border-radius: 50px;
          font-weight: 800;
          text-transform: uppercase;
          font-family: var(--font-secondary);
          font-size: 13px;
          letter-spacing: 0.15em;
          transition: 0.4s;
          display: inline-flex;
          align-items: center;
          gap: 15px;
        }

        .cta-btn-refined:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px ${theme.accent}44;
        }

        .itinerary-details-section {
          padding: 90px 0;
          background: ${theme.bg};
          color: ${theme.text};
        }

        .itinerary-block {
          background: ${theme.cardBg};
          border: 1px solid ${theme.border};
          border-radius: 24px;
          padding: 35px;
          margin-bottom: 35px;
        }

        .itinerary-section-title {
          font-family: var(--font-heading);
          font-size: clamp(28px, 4vw, 44px);
          font-weight: 800;
          margin-bottom: 28px;
          color: ${theme.text};
        }

        .itinerary-days-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 22px;
        }

        .itinerary-day-card {
          background: ${isDarkExperience ? "rgba(255,255,255,0.04)" : "#fff"};
          border: 1px solid ${theme.border};
          border-radius: 20px;
          padding: 24px;
          height: 100%;
        }

        .itinerary-day-label {
          display: inline-block;
          color: ${theme.accent};
          font-size: 12px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.16em;
          margin-bottom: 10px;
        }

        .itinerary-day-card h4 {
          font-family: var(--font-heading);
          font-size: 22px;
          font-weight: 800;
          margin-bottom: 14px;
          color: ${theme.text};
        }

        .itinerary-day-card ul,
        .itinerary-list {
          padding-${isAR ? "right" : "left"}: 20px;
          margin: 0;
        }

        .itinerary-day-card li,
        .itinerary-list li {
          margin-bottom: 10px;
          line-height: 1.7;
          opacity: 0.82;
        }

        .itinerary-rates-table-wrap {
          overflow-x: auto;
          border-radius: 18px;
          border: 1px solid ${theme.border};
        }

        .itinerary-rates-table {
          width: 100%;
          min-width: 760px;
          border-collapse: collapse;
          overflow: hidden;
        }

        .itinerary-rates-table th,
        .itinerary-rates-table td {
          padding: 16px 18px;
          border-bottom: 1px solid ${theme.border};
          text-align: ${isAR ? "right" : "left"};
          white-space: nowrap;
        }

        .itinerary-rates-table th {
          background: ${theme.accent};
          color: ${isDarkExperience && theme.accent === "#d4af37" ? "#000" : "#fff"};
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        .itinerary-rates-table td {
          color: ${theme.text};
          background: ${isDarkExperience ? "rgba(255,255,255,0.025)" : "#fff"};
          font-weight: 700;
        }

        .itinerary-note {
          margin-top: 18px;
          padding: 16px 18px;
          border-radius: 16px;
          background: ${isDarkExperience ? "rgba(212,175,55,0.09)" : "rgba(174,0,1,0.06)"};
          border: 1px solid ${isDarkExperience ? "rgba(212,175,55,0.22)" : "rgba(174,0,1,0.16)"};
          color: ${theme.text};
          line-height: 1.7;
        }

        .itinerary-split-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 24px;
        }

        @media (max-width: 991px) {
          .page-banner {
            height: 45vh;
            margin-bottom: 50px;
          }

          .sidebar-card-final {
            position: static;
            margin-top: 50px;
          }

          .stat-item-refined {
            border: none;
            border-bottom: 1px solid rgba(255,255,255,0.1);
          }
        }

        @media (max-width: 768px) {
          .itinerary-days-grid,
          .itinerary-split-grid {
            grid-template-columns: 1fr;
          }

          .itinerary-block {
            padding: 24px;
          }
        }

        @media (max-width: 575px) {
          .page-banner {
            min-height: 420px;
          }

          .breadcrumbs {
            flex-wrap: wrap;
            font-size: 11px;
          }

          .about-content-refined p {
            font-size: 15px;
          }

          .sidebar-card-final {
            padding: 28px;
          }
        }
      `}</style>

      <section className="page-banner">
        <Container className="banner-content">
          <h1 className="reveal-up">{service.title[langKey]}</h1>
          <div className="breadcrumbs reveal-up">
            <Link to="/">{isAR ? "الرئيسية" : "Home"}</Link>
            {isAR ? <FaArrowLeft size={12} /> : <FaArrowRight size={12} />}
            <Link to="/ourservicepage">{isAR ? "خدماتنا" : "Services"}</Link>
            {isAR ? <FaArrowLeft size={12} /> : <FaArrowRight size={12} />}
            <span>{service.title[langKey]}</span>
          </div>
        </Container>
      </section>

      <section className="refined-about-section">
        <Container>
          <Row className="align-items-center gy-5">
            <Col lg={6} className={isAR ? "order-lg-2" : ""}>
              <div className="about-visual-container reveal-up">
                <div className="about-decorative-glow"></div>
                <img src={service.image} alt={service.title[langKey]} />
              </div>
            </Col>

            <Col lg={6} className={isAR ? "order-lg-1" : ""}>
              <div className="about-content-refined reveal-up">
                <h2>
                  {isAR ? "عن" : "About"}{" "}
                  <span className={isPremium ? "gold-accent-text" : ""}>
                    {service.title[langKey]}
                  </span>
                </h2>
                <p>{service.text[langKey]}</p>
                <button
                  className="cta-btn-refined"
                  onClick={() => navigate("/#contact")}
                >
                  <FaPlane /> {service.cta[langKey]}
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {service.stats && (
        <section className="stats-section-final">
          <Container>
            <h6
              className="gallery-eyebrow reveal-up"
              style={{ color: "#fff", opacity: 0.7 }}
            >
              {service.title[langKey]}
            </h6>
            <h2
              className="gallery-title reveal-up mb-5"
              style={{ color: "#fff" }}
            >
              {isAR ? "بالأرقام" : "In Numbers"}
            </h2>
            <Row className="reveal-up">
              {service.stats.map((stat, i) => (
                <Col md={3} sm={6} key={i}>
                  <div className="stat-item-refined">
                    <span className="stat-value-refined">
                      {stat.value.includes("+")
                        ? stat.value.replace("+", "")
                        : stat.value}
                      {stat.value.includes("+") && (
                        <span className="stat-plus">+</span>
                      )}
                    </span>
                    <span className="stat-label-refined">
                      {stat.label[langKey]}
                    </span>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}

      <Container className="py-24">
        <Row className="gy-5">
          <Col lg={8}>
            <div className="reveal-up">
              <h3
                className="mb-5 mt-3"
                style={{
                  fontFamily: "var(--font-heading)",
                  fontWeight: 800,
                  fontSize: "36px",
                }}
              >
                {isAR ? "المزايا الأساسية" : "Key Benefits"}
              </h3>

              <Row className="gy-4">
                {service.benefits[langKey].map((benefit, i) => (
                  <Col md={6} key={i}>
                    <div className="benefit-card-final">
                      <FaCheckCircle
                        color={theme.accent}
                        size={24}
                        className="mb-3"
                      />
                      <h4
                        style={{
                          fontSize: "18px",
                          fontWeight: 800,
                          marginBottom: "10px",
                        }}
                      >
                        {benefit}
                      </h4>
                      <p style={{ fontSize: "14px", opacity: 0.6, margin: 0 }}>
                        {isAR
                          ? "ضمان أعلى معايير الجودة والاحترافية في التنفيذ."
                          : "Ensuring the highest standards of quality and professional execution."}
                      </p>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>

          <Col lg={4}>
            <div className="sidebar-card-final reveal-up">
              <h3
                className="mb-4"
                style={{
                  fontFamily: "var(--font-heading)",
                  fontSize: "24px",
                }}
              >
                {isAR ? "معلومات الخدمة" : "Service Information"}
              </h3>

              <div className="info-pill-final">
                <div className="pill-icon">
                  <FaUserFriends />
                </div>
                <div>
                  <span className="pill-label">
                    {isAR ? "الجمهور المستهدف" : "Target Audience"}
                  </span>
                  <span className="pill-value">
                    {service.audience[langKey]}
                  </span>
                </div>
              </div>

              <div className="info-pill-final">
                <div className="pill-icon">
                  <FaRegClock />
                </div>
                <div>
                  <span className="pill-label">
                    {isAR ? "المدة المتوقعة" : "Expected Duration"}
                  </span>
                  <span className="pill-value">
                    {service.duration[langKey]}
                  </span>
                </div>
              </div>

              <div className="info-pill-final">
                <div className="pill-icon">
                  <FaAward />
                </div>
                <div>
                  <span className="pill-label">
                    {isAR ? "الجودة" : "Quality"}
                  </span>
                  <span className="pill-value">
                    {isItinerary
                      ? service.title.en.includes("Category A")
                        ? "5 Stars"
                        : "4 Stars"
                      : isAR
                        ? "معايير عالمية"
                        : "Global Standards"}
                  </span>
                </div>
              </div>

              <div className="info-pill-final">
                <div className="pill-icon">
                  <FaUserCheck />
                </div>
                <div>
                  <span className="pill-label">
                    {isAR ? "الخصوصية" : "Privacy"}
                  </span>
                  <span className="pill-value">
                    {isAR ? "سرية تامة" : "Full Discretion"}
                  </span>
                </div>
              </div>

              {isItinerary && (
                <div className="info-pill-final">
                  <div className="pill-icon">
                    <FaPlane />
                  </div>
                  <div>
                    <span className="pill-label">
                      {isAR ? "يبدأ من" : "Starting From"}
                    </span>
                    <span className="pill-value">
                      {
                        service.stats?.find((item) => item.label.en === "From")
                          ?.value
                      }
                    </span>
                  </div>
                </div>
              )}

              <div
                className="mt-5 pt-4 border-top text-center"
                style={{ borderColor: "rgba(255,255,255,0.1)" }}
              >
                <p className="small opacity-50 mb-3">
                  {isAR ? "أو تواصل معنا مباشرة" : "Or contact us directly"}
                </p>
                <a
                  href="tel:+34614909102"
                  className="text-white text-decoration-none h4 d-block fw-bold"
                >
                  +34 614 909 102
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {isItinerary && (
        <section className="itinerary-details-section">
          <Container>
            <div className="itinerary-block reveal-up">
              <h2 className="itinerary-section-title">
                {isAR ? "تفاصيل البرنامج" : "Detailed Itinerary"}
              </h2>

              <div className="itinerary-days-grid">
                {service.itinerary[langKey].map((day, index) => (
                  <div className="itinerary-day-card" key={index}>
                    <span className="itinerary-day-label">{day.day}</span>
                    <h4>{day.title}</h4>
                    <ul>
                      {day.highlights.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                    <div
                      className="mt-4 pt-3"
                      style={{ borderTop: `1px solid ${theme.border}` }}
                    >
                      <strong>{isAR ? "الإقامة: " : "Overnight: "}</strong>
                      <span>{day.overnight}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="itinerary-block reveal-up">
              <h2 className="itinerary-section-title">
                {isAR ? "الأسعار" : "Rates"}
              </h2>

              <div className="itinerary-rates-table-wrap">
                <table className="itinerary-rates-table">
                  <thead>
                    <tr>
                      <th>{isAR ? "الفترة" : "Period"}</th>
                      <th>2 Pax</th>
                      <th>3-4 Pax</th>
                      <th>5-7 Pax</th>
                      <th>8-10 Pax</th>
                    </tr>
                  </thead>
                  <tbody>
                    {service.rates.map((rate, index) => (
                      <tr key={index}>
                        <td>{rate.period}</td>
                        <td>{formatMoney(rate.pax2)}</td>
                        <td>{formatMoney(rate.pax3To4)}</td>
                        <td>{formatMoney(rate.pax5To7)}</td>
                        <td>
                          {formatMoney(rate.pax8To10)}
                          {rate.reviewRequired && (
                            <span
                              style={{
                                color: theme.accent,
                                marginInlineStart: 8,
                              }}
                            >
                              *
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="itinerary-note">
                <strong>
                  {isAR ? "الطيران الداخلي: " : "Domestic Flight: "}
                </strong>
                {service.domesticFlight.route} —{" "}
                {formatMoney(service.domesticFlight.perAdult)}{" "}
                {isAR ? "للفرد" : "per adult"} — {service.domesticFlight.note}
              </div>

              {service.rates.some((rate) => rate.reviewRequired) && (
                <div className="itinerary-note">
                  {isAR
                    ? "يوجد رقم في جدول سبتمبر يحتاج مراجعة قبل النشر لأنه ظاهر كما هو في ملف المصدر."
                    : "One September rate needs confirmation before publishing because it is displayed as shown in the source file."}
                </div>
              )}
            </div>

            <div className="itinerary-split-grid reveal-up">
              <div className="itinerary-block">
                <h2 className="itinerary-section-title">
                  {isAR ? "يشمل" : "Inclusions"}
                </h2>
                <ul className="itinerary-list">
                  {service.inclusions[langKey].map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="itinerary-block">
                <h2 className="itinerary-section-title">
                  {isAR ? "لا يشمل" : "Exclusions"}
                </h2>
                <ul className="itinerary-list">
                  {service.exclusions[langKey].map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="itinerary-block reveal-up">
              <h2 className="itinerary-section-title">
                {isAR ? "ملاحظات" : "Notes"}
              </h2>
              <ul className="itinerary-list">
                {service.notes[langKey].map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </Container>
        </section>
      )}

      {service.gallery && (
        <section className="gallery-section-final">
          <div className="gallery-header reveal-up">
            <span className="gallery-eyebrow">Gallery</span>
            <h2 className="gallery-title">{service.title[langKey]}</h2>
          </div>

          <div className="gallery-swiper-shell container reveal-up">
            <button
              type="button"
              className={`gallery-nav-btn gallery-nav-prev ${galleryScope}-prev`}
              aria-label={isAR ? "الصورة السابقة" : "Previous image"}
            >
              {isAR ? <FaArrowRight /> : <FaArrowLeft />}
            </button>

            <button
              type="button"
              className={`gallery-nav-btn gallery-nav-next ${galleryScope}-next`}
              aria-label={isAR ? "الصورة التالية" : "Next image"}
            >
              {isAR ? <FaArrowLeft /> : <FaArrowRight />}
            </button>

            <div
              className={`gallery-custom-pagination ${galleryScope}-pagination`}
            ></div>

            <Swiper
              modules={[Pagination, Navigation, Autoplay]}
              spaceBetween={28}
              slidesPerView={1}
              centeredSlides={true}
              loop={service.gallery.length > 1}
              speed={750}
              autoplay={{
                delay: 3600,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              pagination={{
                el: `.${galleryScope}-pagination`,
                clickable: true,
              }}
              navigation={{
                prevEl: `.${galleryScope}-prev`,
                nextEl: `.${galleryScope}-next`,
              }}
              observer={true}
              observeParents={true}
              breakpoints={{
                768: {
                  slidesPerView: 1.15,
                  spaceBetween: 28,
                },
                1024: {
                  slidesPerView: 1.35,
                  spaceBetween: 34,
                },
                1280: {
                  slidesPerView: 1.5,
                  spaceBetween: 36,
                },
              }}
              className="gallery-swiper"
            >
              {service.gallery.map((img, i) => (
                <SwiperSlide key={i}>
                  <div className="gallery-slide-card">
                    <img
                      src={img}
                      alt={`${service.title[langKey]} gallery ${i + 1}`}
                      className="gallery-slide-img"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      )}

      <div
        className="fixed inset-0 w-full h-full pointer-events-none"
        style={{ zIndex: 0 }}
      >
        <Particles
          particleColors={
            isPremium ? ["#ffffff", "#d4af37"] : ["#2c3b5b", "#ae0001"]
          }
          particleCount={250}
          particleSpread={12}
          speed={0.12}
          particleBaseSize={120}
          moveParticlesOnHover={true}
          alphaParticles={true}
          disableRotation={false}
          pixelRatio={1}
        />
      </div>
    </div>
  );
}
